/* eslint-disable */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.5
// Generated from `ActGuildAllStarServant.jce'
// **********************************************************************

var HUYA = HUYA || {};


HUYA.EGender = 
{
    MALE: 0,
    FEMALE: 1
};


HUYA.AccompanyTag = function()
{
    this.iTagId = 0;
    this.sName = "";
    this.sIconUrl = "";
    this.sDesc = "";
    this.iType = 0;
    this.sValue = "";
};
HUYA.AccompanyTag.prototype._clone = function () { return new HUYA.AccompanyTag(); }
HUYA.AccompanyTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.AccompanyTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.AccompanyTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTagId);
    os.writeString(1, this.sName);
    os.writeString(2, this.sIconUrl);
    os.writeString(3, this.sDesc);
    os.writeInt32(4, this.iType);
    os.writeString(5, this.sValue);
};

HUYA.AccompanyTag.prototype.readFrom = function (is)
{
    this.iTagId= is.readInt32(0, false, this.iTagId);
    this.sName= is.readString(1, false, this.sName);
    this.sIconUrl= is.readString(2, false, this.sIconUrl);
    this.sDesc= is.readString(3, false, this.sDesc);
    this.iType= is.readInt32(4, false, this.iType);
    this.sValue= is.readString(5, false, this.sValue);
};

HUYA.ACDiscountsPriceInfo = function()
{
    this.iType = 0;
    this.iDiscount = 0;
    this.iDiscountPrice = 0;
    this.iSrcPrice = 0;
    this.sUnit = "";
};
HUYA.ACDiscountsPriceInfo.prototype._clone = function () { return new HUYA.ACDiscountsPriceInfo(); }
HUYA.ACDiscountsPriceInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACDiscountsPriceInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACDiscountsPriceInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeInt32(1, this.iDiscount);
    os.writeInt32(2, this.iDiscountPrice);
    os.writeInt32(3, this.iSrcPrice);
    os.writeString(4, this.sUnit);
};

HUYA.ACDiscountsPriceInfo.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.iDiscount= is.readInt32(1, false, this.iDiscount);
    this.iDiscountPrice= is.readInt32(2, false, this.iDiscountPrice);
    this.iSrcPrice= is.readInt32(3, false, this.iSrcPrice);
    this.sUnit= is.readString(4, false, this.sUnit);
};

HUYA.ACStatusExt = function()
{
    this.lTime = 0;
    this.lUid = 0;
    this.sExt = "";
    this.iStatus = 0;
    this.sReason = "";
    this.iExtType = 0;
    this.data = new Taf.BinBuffer();
};
HUYA.ACStatusExt.prototype._clone = function () { return new HUYA.ACStatusExt(); }
HUYA.ACStatusExt.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACStatusExt.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACStatusExt.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTime);
    os.writeInt64(1, this.lUid);
    os.writeString(2, this.sExt);
    os.writeInt32(3, this.iStatus);
    os.writeString(4, this.sReason);
    os.writeInt32(5, this.iExtType);
    os.writeBytes(6, this.data);
};

HUYA.ACStatusExt.prototype.readFrom = function (is)
{
    this.lTime= is.readInt64(0, false, this.lTime);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.sExt= is.readString(2, false, this.sExt);
    this.iStatus= is.readInt32(3, false, this.iStatus);
    this.sReason= is.readString(4, false, this.sReason);
    this.iExtType= is.readInt32(5, false, this.iExtType);
    this.data= is.readBytes(6, false, this.data);
};

HUYA.ACCouponStatuInfo = function()
{
    this.iStatus = 0;
    this.sId = "";
    this.lGetTime = 0;
    this.sOid = "";
    this.lUid = 0;
    this.sCouponUrl = "";
    this.lUseTime = 0;
};
HUYA.ACCouponStatuInfo.prototype._clone = function () { return new HUYA.ACCouponStatuInfo(); }
HUYA.ACCouponStatuInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACCouponStatuInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACCouponStatuInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStatus);
    os.writeString(1, this.sId);
    os.writeInt64(2, this.lGetTime);
    os.writeString(3, this.sOid);
    os.writeInt64(4, this.lUid);
    os.writeString(5, this.sCouponUrl);
    os.writeInt64(6, this.lUseTime);
};

HUYA.ACCouponStatuInfo.prototype.readFrom = function (is)
{
    this.iStatus= is.readInt32(0, false, this.iStatus);
    this.sId= is.readString(1, false, this.sId);
    this.lGetTime= is.readInt64(2, false, this.lGetTime);
    this.sOid= is.readString(3, false, this.sOid);
    this.lUid= is.readInt64(4, false, this.lUid);
    this.sCouponUrl= is.readString(5, false, this.sCouponUrl);
    this.lUseTime= is.readInt64(6, false, this.lUseTime);
};

HUYA.ACCouponBase = function()
{
    this.lCid = 0;
    this.lCreateTime = 0;
    this.sName = "";
    this.iPrice = 0;
    this.iThreshold = 0;
    this.lEndTime = 0;
    this.lBgnTime = 0;
    this.iDispathType = 0;
    this.lPid = 0;
    this.lPidHuya = 0;
    this.sGroupId = "";
    this.sCouponUrl = "";
    this.lPayUid = 0;
};
HUYA.ACCouponBase.prototype._clone = function () { return new HUYA.ACCouponBase(); }
HUYA.ACCouponBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACCouponBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACCouponBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lCid);
    os.writeInt64(1, this.lCreateTime);
    os.writeString(2, this.sName);
    os.writeInt32(3, this.iPrice);
    os.writeInt32(4, this.iThreshold);
    os.writeInt64(5, this.lEndTime);
    os.writeInt64(6, this.lBgnTime);
    os.writeInt32(7, this.iDispathType);
    os.writeInt64(8, this.lPid);
    os.writeInt64(9, this.lPidHuya);
    os.writeString(10, this.sGroupId);
    os.writeString(11, this.sCouponUrl);
    os.writeInt64(12, this.lPayUid);
};

HUYA.ACCouponBase.prototype.readFrom = function (is)
{
    this.lCid= is.readInt64(0, false, this.lCid);
    this.lCreateTime= is.readInt64(1, false, this.lCreateTime);
    this.sName= is.readString(2, false, this.sName);
    this.iPrice= is.readInt32(3, false, this.iPrice);
    this.iThreshold= is.readInt32(4, false, this.iThreshold);
    this.lEndTime= is.readInt64(5, false, this.lEndTime);
    this.lBgnTime= is.readInt64(6, false, this.lBgnTime);
    this.iDispathType= is.readInt32(7, false, this.iDispathType);
    this.lPid= is.readInt64(8, false, this.lPid);
    this.lPidHuya= is.readInt64(9, false, this.lPidHuya);
    this.sGroupId= is.readString(10, false, this.sGroupId);
    this.sCouponUrl= is.readString(11, false, this.sCouponUrl);
    this.lPayUid= is.readInt64(12, false, this.lPayUid);
};

HUYA.FaithPresenter = function()
{
    this.lPid = 0;
    this.sLogo = "";
};
HUYA.FaithPresenter.prototype._clone = function () { return new HUYA.FaithPresenter(); }
HUYA.FaithPresenter.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FaithPresenter.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FaithPresenter.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sLogo);
};

HUYA.FaithPresenter.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sLogo= is.readString(1, false, this.sLogo);
};

HUYA.AccompanySkillProfile = function()
{
    this.iId = 0;
    this.sName = "";
    this.sIcon = "";
    this.sDesc = "";
    this.sLevel = "";
    this.sUnit = "";
    this.sGameZone = "";
    this.vRemarkTags = new Taf.Vector(new Taf.STRING());
};
HUYA.AccompanySkillProfile.prototype._clone = function () { return new HUYA.AccompanySkillProfile(); }
HUYA.AccompanySkillProfile.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.AccompanySkillProfile.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.AccompanySkillProfile.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iId);
    os.writeString(1, this.sName);
    os.writeString(2, this.sIcon);
    os.writeString(3, this.sDesc);
    os.writeString(4, this.sLevel);
    os.writeString(5, this.sUnit);
    os.writeString(6, this.sGameZone);
    os.writeVector(7, this.vRemarkTags);
};

HUYA.AccompanySkillProfile.prototype.readFrom = function (is)
{
    this.iId= is.readInt32(0, false, this.iId);
    this.sName= is.readString(1, false, this.sName);
    this.sIcon= is.readString(2, false, this.sIcon);
    this.sDesc= is.readString(3, false, this.sDesc);
    this.sLevel= is.readString(4, false, this.sLevel);
    this.sUnit= is.readString(5, false, this.sUnit);
    this.sGameZone= is.readString(6, false, this.sGameZone);
    this.vRemarkTags= is.readVector(7, false, this.vRemarkTags);
};

HUYA.AccompanyMasterSkillProfile = function()
{
    this.lMasterUid = 0;
    this.iSkillId = 0;
    this.sLevel = "";
    this.iOrderCount = 0;
    this.iPrice = 0;
    this.sVoiceIntro = "";
    this.vTags = new Taf.Vector(new HUYA.AccompanyTag());
    this.iVoiceLength = 0;
    this.sSkillLicense = "";
    this.iStar = 0;
    this.sIntroduce = "";
    this.tDiscountsInfo = new HUYA.ACDiscountsPriceInfo();
    this.vExtTag = new Taf.Vector(new HUYA.AccompanyTag());
    this.iCustomerCount = 0;
};
HUYA.AccompanyMasterSkillProfile.prototype._clone = function () { return new HUYA.AccompanyMasterSkillProfile(); }
HUYA.AccompanyMasterSkillProfile.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.AccompanyMasterSkillProfile.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.AccompanyMasterSkillProfile.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lMasterUid);
    os.writeInt32(1, this.iSkillId);
    os.writeString(2, this.sLevel);
    os.writeInt32(3, this.iOrderCount);
    os.writeInt32(4, this.iPrice);
    os.writeString(5, this.sVoiceIntro);
    os.writeVector(6, this.vTags);
    os.writeInt32(7, this.iVoiceLength);
    os.writeString(8, this.sSkillLicense);
    os.writeInt32(9, this.iStar);
    os.writeString(10, this.sIntroduce);
    os.writeStruct(11, this.tDiscountsInfo);
    os.writeVector(12, this.vExtTag);
    os.writeInt32(13, this.iCustomerCount);
};

HUYA.AccompanyMasterSkillProfile.prototype.readFrom = function (is)
{
    this.lMasterUid= is.readInt64(0, false, this.lMasterUid);
    this.iSkillId= is.readInt32(1, false, this.iSkillId);
    this.sLevel= is.readString(2, false, this.sLevel);
    this.iOrderCount= is.readInt32(3, false, this.iOrderCount);
    this.iPrice= is.readInt32(4, false, this.iPrice);
    this.sVoiceIntro= is.readString(5, false, this.sVoiceIntro);
    this.vTags= is.readVector(6, false, this.vTags);
    this.iVoiceLength= is.readInt32(7, false, this.iVoiceLength);
    this.sSkillLicense= is.readString(8, false, this.sSkillLicense);
    this.iStar= is.readInt32(9, false, this.iStar);
    this.sIntroduce= is.readString(10, false, this.sIntroduce);
    this.tDiscountsInfo= is.readStruct(11, false, this.tDiscountsInfo);
    this.vExtTag= is.readVector(12, false, this.vExtTag);
    this.iCustomerCount= is.readInt32(13, false, this.iCustomerCount);
};

HUYA.ACStatusExtList = function()
{
    this.mapStatus2Info = new Taf.Map(new Taf.INT32(), new HUYA.ACStatusExt());
};
HUYA.ACStatusExtList.prototype._clone = function () { return new HUYA.ACStatusExtList(); }
HUYA.ACStatusExtList.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACStatusExtList.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACStatusExtList.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mapStatus2Info);
};

HUYA.ACStatusExtList.prototype.readFrom = function (is)
{
    this.mapStatus2Info= is.readMap(0, false, this.mapStatus2Info);
};

HUYA.ACCouponInfo = function()
{
    this.tCP = new HUYA.ACCouponBase();
    this.tInfo = new HUYA.ACCouponStatuInfo();
};
HUYA.ACCouponInfo.prototype._clone = function () { return new HUYA.ACCouponInfo(); }
HUYA.ACCouponInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACCouponInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACCouponInfo.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tCP);
    os.writeStruct(1, this.tInfo);
};

HUYA.ACCouponInfo.prototype.readFrom = function (is)
{
    this.tCP= is.readStruct(0, false, this.tCP);
    this.tInfo= is.readStruct(1, false, this.tInfo);
};

HUYA.ACUserComplainInfo = function()
{
    this.sOrderId = "";
    this.lMTUid = 0;
    this.lCTUid = 0;
    this.vTestimony = new Taf.Vector(new Taf.STRING());
    this.sRefundReason = "";
    this.sRefundReason2 = "";
    this.sDes = "";
    this.sPhone = "";
};
HUYA.ACUserComplainInfo.prototype._clone = function () { return new HUYA.ACUserComplainInfo(); }
HUYA.ACUserComplainInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACUserComplainInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACUserComplainInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sOrderId);
    os.writeInt64(1, this.lMTUid);
    os.writeInt64(2, this.lCTUid);
    os.writeVector(3, this.vTestimony);
    os.writeString(4, this.sRefundReason);
    os.writeString(5, this.sRefundReason2);
    os.writeString(6, this.sDes);
    os.writeString(7, this.sPhone);
};

HUYA.ACUserComplainInfo.prototype.readFrom = function (is)
{
    this.sOrderId= is.readString(0, false, this.sOrderId);
    this.lMTUid= is.readInt64(1, false, this.lMTUid);
    this.lCTUid= is.readInt64(2, false, this.lCTUid);
    this.vTestimony= is.readVector(3, false, this.vTestimony);
    this.sRefundReason= is.readString(4, false, this.sRefundReason);
    this.sRefundReason2= is.readString(5, false, this.sRefundReason2);
    this.sDes= is.readString(6, false, this.sDes);
    this.sPhone= is.readString(7, false, this.sPhone);
};

HUYA.ACComplainOptRecord = function()
{
    this.lUid = 0;
    this.iOpt = 0;
};
HUYA.ACComplainOptRecord.prototype._clone = function () { return new HUYA.ACComplainOptRecord(); }
HUYA.ACComplainOptRecord.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACComplainOptRecord.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACComplainOptRecord.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt32(1, this.iOpt);
};

HUYA.ACComplainOptRecord.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.iOpt= is.readInt32(1, false, this.iOpt);
};

HUYA.LiveAttributeInfo = function()
{
    this.vData = new Taf.BinBuffer();
    this.lTimespan = 0;
    this.lExpTimeMs = 0;
};
HUYA.LiveAttributeInfo.prototype._clone = function () { return new HUYA.LiveAttributeInfo(); }
HUYA.LiveAttributeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveAttributeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveAttributeInfo.prototype.writeTo = function (os)
{
    os.writeBytes(0, this.vData);
    os.writeInt64(1, this.lTimespan);
    os.writeInt64(2, this.lExpTimeMs);
};

HUYA.LiveAttributeInfo.prototype.readFrom = function (is)
{
    this.vData= is.readBytes(0, false, this.vData);
    this.lTimespan= is.readInt64(1, false, this.lTimespan);
    this.lExpTimeMs= is.readInt64(2, false, this.lExpTimeMs);
};

HUYA.GameLiveTag = function()
{
    this.iTagId = 0;
    this.sTagName = "";
    this.bIsShow = true;
    this.iBindingGameId = 0;
    this.iShowType = 0;
};
HUYA.GameLiveTag.prototype._clone = function () { return new HUYA.GameLiveTag(); }
HUYA.GameLiveTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTagId);
    os.writeString(1, this.sTagName);
    os.writeBoolean(2, this.bIsShow);
    os.writeInt32(3, this.iBindingGameId);
    os.writeInt32(4, this.iShowType);
};

HUYA.GameLiveTag.prototype.readFrom = function (is)
{
    this.iTagId= is.readInt32(0, false, this.iTagId);
    this.sTagName= is.readString(1, false, this.sTagName);
    this.bIsShow= is.readBoolean(2, false, this.bIsShow);
    this.iBindingGameId= is.readInt32(3, false, this.iBindingGameId);
    this.iShowType= is.readInt32(4, false, this.iShowType);
};

HUYA.SuperFansInfo = function()
{
    this.lSFExpiredTS = 0;
    this.iSFFlag = 0;
    this.lSFAnnualTS = 0;
};
HUYA.SuperFansInfo.prototype._clone = function () { return new HUYA.SuperFansInfo(); }
HUYA.SuperFansInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SuperFansInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SuperFansInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lSFExpiredTS);
    os.writeInt32(1, this.iSFFlag);
    os.writeInt64(2, this.lSFAnnualTS);
};

HUYA.SuperFansInfo.prototype.readFrom = function (is)
{
    this.lSFExpiredTS= is.readInt64(0, false, this.lSFExpiredTS);
    this.iSFFlag= is.readInt32(1, false, this.iSFFlag);
    this.lSFAnnualTS= is.readInt64(2, false, this.lSFAnnualTS);
};

HUYA.PresenterChannelInfo = function()
{
    this.lYYId = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iSourceType = 0;
    this.iScreenType = 0;
    this.lUid = 0;
    this.iGameId = 0;
    this.iRoomId = 0;
};
HUYA.PresenterChannelInfo.prototype._clone = function () { return new HUYA.PresenterChannelInfo(); }
HUYA.PresenterChannelInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.PresenterChannelInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.PresenterChannelInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lYYId);
    os.writeInt64(1, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt32(4, this.iSourceType);
    os.writeInt32(5, this.iScreenType);
    os.writeInt64(6, this.lUid);
    os.writeInt32(7, this.iGameId);
    os.writeInt32(8, this.iRoomId);
};

HUYA.PresenterChannelInfo.prototype.readFrom = function (is)
{
    this.lYYId= is.readInt64(0, false, this.lYYId);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.iSourceType= is.readInt32(4, false, this.iSourceType);
    this.iScreenType= is.readInt32(5, false, this.iScreenType);
    this.lUid= is.readInt64(6, false, this.lUid);
    this.iGameId= is.readInt32(7, false, this.iGameId);
    this.iRoomId= is.readInt32(8, false, this.iRoomId);
};

HUYA.FaithInfo = function()
{
    this.sFaithName = "";
    this.vPresenter = new Taf.Vector(new HUYA.FaithPresenter());
};
HUYA.FaithInfo.prototype._clone = function () { return new HUYA.FaithInfo(); }
HUYA.FaithInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.FaithInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.FaithInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sFaithName);
    os.writeVector(1, this.vPresenter);
};

HUYA.FaithInfo.prototype.readFrom = function (is)
{
    this.sFaithName= is.readString(0, false, this.sFaithName);
    this.vPresenter= is.readVector(1, false, this.vPresenter);
};

HUYA.UserBase = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.sAvatarUrl = "";
    this.iGender = 0;
    this.lYYId = 0;
    this.iCertified = 0;
    this.iSubscribedCount = 0;
    this.iSubscribeToCount = 0;
    this.iUserLevel = 0;
    this.lUserExp = 0;
    this.iBirthday = 0;
    this.sSign = "";
    this.sArea = "";
    this.sLocation = "";
    this.sRegisterTime = "";
    this.iFreezeTime = 0;
    this.iBindPhone = 0;
    this.sHuyaId = "";
};
HUYA.UserBase.prototype._clone = function () { return new HUYA.UserBase(); }
HUYA.UserBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sAvatarUrl);
    os.writeInt32(3, this.iGender);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iCertified);
    os.writeInt32(6, this.iSubscribedCount);
    os.writeInt32(7, this.iSubscribeToCount);
    os.writeInt32(8, this.iUserLevel);
    os.writeInt64(9, this.lUserExp);
    os.writeInt32(10, this.iBirthday);
    os.writeString(11, this.sSign);
    os.writeString(12, this.sArea);
    os.writeString(13, this.sLocation);
    os.writeString(14, this.sRegisterTime);
    os.writeInt32(15, this.iFreezeTime);
    os.writeInt32(16, this.iBindPhone);
    os.writeString(17, this.sHuyaId);
};

HUYA.UserBase.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sAvatarUrl= is.readString(2, false, this.sAvatarUrl);
    this.iGender= is.readInt32(3, false, this.iGender);
    this.lYYId= is.readInt64(4, false, this.lYYId);
    this.iCertified= is.readInt32(5, false, this.iCertified);
    this.iSubscribedCount= is.readInt32(6, false, this.iSubscribedCount);
    this.iSubscribeToCount= is.readInt32(7, false, this.iSubscribeToCount);
    this.iUserLevel= is.readInt32(8, false, this.iUserLevel);
    this.lUserExp= is.readInt64(9, false, this.lUserExp);
    this.iBirthday= is.readInt32(10, false, this.iBirthday);
    this.sSign= is.readString(11, false, this.sSign);
    this.sArea= is.readString(12, false, this.sArea);
    this.sLocation= is.readString(13, false, this.sLocation);
    this.sRegisterTime= is.readString(14, false, this.sRegisterTime);
    this.iFreezeTime= is.readInt32(15, false, this.iFreezeTime);
    this.iBindPhone= is.readInt32(16, false, this.iBindPhone);
    this.sHuyaId= is.readString(17, false, this.sHuyaId);
};

HUYA.MasterLevelBase = function()
{
    this.lMasterUid = 0;
    this.iLevel = 0;
    this.iLightUp = 0;
};
HUYA.MasterLevelBase.prototype._clone = function () { return new HUYA.MasterLevelBase(); }
HUYA.MasterLevelBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MasterLevelBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MasterLevelBase.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lMasterUid);
    os.writeInt32(1, this.iLevel);
    os.writeInt32(2, this.iLightUp);
};

HUYA.MasterLevelBase.prototype.readFrom = function (is)
{
    this.lMasterUid= is.readInt64(0, false, this.lMasterUid);
    this.iLevel= is.readInt32(1, false, this.iLevel);
    this.iLightUp= is.readInt32(2, false, this.iLightUp);
};

HUYA.AccompanyMasterSkillDetail = function()
{
    this.tBase = new HUYA.AccompanySkillProfile();
    this.tStat = new HUYA.AccompanyMasterSkillProfile();
    this.sJump = "";
};
HUYA.AccompanyMasterSkillDetail.prototype._clone = function () { return new HUYA.AccompanyMasterSkillDetail(); }
HUYA.AccompanyMasterSkillDetail.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.AccompanyMasterSkillDetail.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.AccompanyMasterSkillDetail.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBase);
    os.writeStruct(1, this.tStat);
    os.writeString(2, this.sJump);
};

HUYA.AccompanyMasterSkillDetail.prototype.readFrom = function (is)
{
    this.tBase= is.readStruct(0, false, this.tBase);
    this.tStat= is.readStruct(1, false, this.tStat);
    this.sJump= is.readString(2, false, this.sJump);
};

HUYA.ACOrderDes = function()
{
    this.sStatuTitle = "";
    this.sStatuSubhead = "";
};
HUYA.ACOrderDes.prototype._clone = function () { return new HUYA.ACOrderDes(); }
HUYA.ACOrderDes.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACOrderDes.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACOrderDes.prototype.writeTo = function (os)
{
    os.writeString(0, this.sStatuTitle);
    os.writeString(1, this.sStatuSubhead);
};

HUYA.ACOrderDes.prototype.readFrom = function (is)
{
    this.sStatuTitle= is.readString(0, false, this.sStatuTitle);
    this.sStatuSubhead= is.readString(1, false, this.sStatuSubhead);
};

HUYA.ACOrderContext = function()
{
    this.mpContext = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.ACOrderContext.prototype._clone = function () { return new HUYA.ACOrderContext(); }
HUYA.ACOrderContext.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACOrderContext.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACOrderContext.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mpContext);
};

HUYA.ACOrderContext.prototype.readFrom = function (is)
{
    this.mpContext= is.readMap(0, false, this.mpContext);
};

HUYA.ACOrderBase = function()
{
    this.sId = "";
    this.lCreateTime = 0;
    this.tSatusExtList = new HUYA.ACStatusExtList();
    this.iPrice = 0;
    this.iNum = 0;
    this.iCost = 0;
    this.iStatus = 0;
    this.iServiceTime = 0;
    this.iCurStatusReason = 0;
    this.lRemain = 0;
    this.lMasterUid = 0;
    this.lCustomerUid = 0;
    this.sPayId = "";
    this.iSkillId = 0;
    this.sRefundId = "";
    this.lFinishTime = 0;
    this.iSrcType = 0;
    this.sSrcExt = "";
    this.lCid = 0;
    this.sHistory = "";
    this.sExt = "";
    this.vHistory = new Taf.Vector(new HUYA.ACStatusExt());
    this.tDisc = new HUYA.ACDiscountsPriceInfo();
    this.iDisType = 0;
    this.tCP = new HUYA.ACCouponInfo();
    this.iPayStatus = 0;
    this.iRefundStatus = 0;
    this.lCurStatusTime = 0;
};
HUYA.ACOrderBase.prototype._clone = function () { return new HUYA.ACOrderBase(); }
HUYA.ACOrderBase.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACOrderBase.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACOrderBase.prototype.writeTo = function (os)
{
    os.writeString(0, this.sId);
    os.writeInt64(1, this.lCreateTime);
    os.writeStruct(2, this.tSatusExtList);
    os.writeInt32(3, this.iPrice);
    os.writeInt32(4, this.iNum);
    os.writeInt64(5, this.iCost);
    os.writeInt32(6, this.iStatus);
    os.writeInt64(7, this.iServiceTime);
    os.writeInt32(8, this.iCurStatusReason);
    os.writeInt64(9, this.lRemain);
    os.writeInt64(10, this.lMasterUid);
    os.writeInt64(11, this.lCustomerUid);
    os.writeString(12, this.sPayId);
    os.writeInt32(13, this.iSkillId);
    os.writeString(14, this.sRefundId);
    os.writeInt64(15, this.lFinishTime);
    os.writeInt32(16, this.iSrcType);
    os.writeString(17, this.sSrcExt);
    os.writeInt64(18, this.lCid);
    os.writeString(19, this.sHistory);
    os.writeString(20, this.sExt);
    os.writeVector(22, this.vHistory);
    os.writeStruct(23, this.tDisc);
    os.writeInt32(25, this.iDisType);
    os.writeStruct(26, this.tCP);
    os.writeInt32(27, this.iPayStatus);
    os.writeInt32(28, this.iRefundStatus);
    os.writeInt64(29, this.lCurStatusTime);
};

HUYA.ACOrderBase.prototype.readFrom = function (is)
{
    this.sId= is.readString(0, false, this.sId);
    this.lCreateTime= is.readInt64(1, false, this.lCreateTime);
    this.tSatusExtList= is.readStruct(2, false, this.tSatusExtList);
    this.iPrice= is.readInt32(3, false, this.iPrice);
    this.iNum= is.readInt32(4, false, this.iNum);
    this.iCost= is.readInt64(5, false, this.iCost);
    this.iStatus= is.readInt32(6, false, this.iStatus);
    this.iServiceTime= is.readInt64(7, false, this.iServiceTime);
    this.iCurStatusReason= is.readInt32(8, false, this.iCurStatusReason);
    this.lRemain= is.readInt64(9, false, this.lRemain);
    this.lMasterUid= is.readInt64(10, false, this.lMasterUid);
    this.lCustomerUid= is.readInt64(11, false, this.lCustomerUid);
    this.sPayId= is.readString(12, false, this.sPayId);
    this.iSkillId= is.readInt32(13, false, this.iSkillId);
    this.sRefundId= is.readString(14, false, this.sRefundId);
    this.lFinishTime= is.readInt64(15, false, this.lFinishTime);
    this.iSrcType= is.readInt32(16, false, this.iSrcType);
    this.sSrcExt= is.readString(17, false, this.sSrcExt);
    this.lCid= is.readInt64(18, false, this.lCid);
    this.sHistory= is.readString(19, false, this.sHistory);
    this.sExt= is.readString(20, false, this.sExt);
    this.vHistory= is.readVector(22, false, this.vHistory);
    this.tDisc= is.readStruct(23, false, this.tDisc);
    this.iDisType= is.readInt32(25, false, this.iDisType);
    this.tCP= is.readStruct(26, false, this.tCP);
    this.iPayStatus= is.readInt32(27, false, this.iPayStatus);
    this.iRefundStatus= is.readInt32(28, false, this.iRefundStatus);
    this.lCurStatusTime= is.readInt64(29, false, this.lCurStatusTime);
};

HUYA.ACComplainInfo = function()
{
    this.sId = "";
    this.tCustomerCInfo = new HUYA.ACUserComplainInfo();
    this.tMasterCInfo = new HUYA.ACUserComplainInfo();
    this.iStatus = 0;
    this.mHistory = new Taf.Map(new Taf.INT64(), new HUYA.ACComplainOptRecord());
};
HUYA.ACComplainInfo.prototype._clone = function () { return new HUYA.ACComplainInfo(); }
HUYA.ACComplainInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACComplainInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACComplainInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sId);
    os.writeStruct(1, this.tCustomerCInfo);
    os.writeStruct(2, this.tMasterCInfo);
    os.writeInt32(3, this.iStatus);
    os.writeMap(4, this.mHistory);
};

HUYA.ACComplainInfo.prototype.readFrom = function (is)
{
    this.sId= is.readString(0, false, this.sId);
    this.tCustomerCInfo= is.readStruct(1, false, this.tCustomerCInfo);
    this.tMasterCInfo= is.readStruct(2, false, this.tMasterCInfo);
    this.iStatus= is.readInt32(3, false, this.iStatus);
    this.mHistory= is.readMap(4, false, this.mHistory);
};

HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};

HUYA.GameLiveMisc = function()
{
    this.mMiscInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.sIP = "";
    this.sGuid = "";
    this.iPresentType = 0;
    this.sGPSInfo = "";
    this.lBonusValue = 0;
    this.sIPLocation = "";
    this.sHuYaUA = "";
    this.iScore = 0;
    this.lRealAttendeeCount = 0;
    this.lSubscribedCount = 0;
    this.mpAttribute = new Taf.Map(new Taf.STRING(), new HUYA.LiveAttributeInfo());
    this.sPassword = "";
};
HUYA.GameLiveMisc.prototype._clone = function () { return new HUYA.GameLiveMisc(); }
HUYA.GameLiveMisc.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveMisc.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveMisc.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mMiscInfo);
    os.writeString(1, this.sIP);
    os.writeString(2, this.sGuid);
    os.writeInt32(3, this.iPresentType);
    os.writeString(4, this.sGPSInfo);
    os.writeInt64(5, this.lBonusValue);
    os.writeString(6, this.sIPLocation);
    os.writeString(7, this.sHuYaUA);
    os.writeInt64(8, this.iScore);
    os.writeInt64(9, this.lRealAttendeeCount);
    os.writeInt64(10, this.lSubscribedCount);
    os.writeMap(11, this.mpAttribute);
    os.writeString(12, this.sPassword);
};

HUYA.GameLiveMisc.prototype.readFrom = function (is)
{
    this.mMiscInfo= is.readMap(0, false, this.mMiscInfo);
    this.sIP= is.readString(1, false, this.sIP);
    this.sGuid= is.readString(2, false, this.sGuid);
    this.iPresentType= is.readInt32(3, false, this.iPresentType);
    this.sGPSInfo= is.readString(4, false, this.sGPSInfo);
    this.lBonusValue= is.readInt64(5, false, this.lBonusValue);
    this.sIPLocation= is.readString(6, false, this.sIPLocation);
    this.sHuYaUA= is.readString(7, false, this.sHuYaUA);
    this.iScore= is.readInt64(8, false, this.iScore);
    this.lRealAttendeeCount= is.readInt64(9, false, this.lRealAttendeeCount);
    this.lSubscribedCount= is.readInt64(10, false, this.lSubscribedCount);
    this.mpAttribute= is.readMap(11, false, this.mpAttribute);
    this.sPassword= is.readString(12, false, this.sPassword);
};

HUYA.GameLiveInfo = function()
{
    this.lLiveId = 0;
    this.lUid = 0;
    this.lChannelId = 0;
    this.iShortChannel = 0;
    this.lSubchannel = 0;
    this.sSubchannelName = "";
    this.iGameId = 0;
    this.sGameName = "";
    this.iAttendeeCount = 0;
    this.eGender = HUYA.EGender.MALE;
    this.iAid = 0;
    this.sNick = "";
    this.sAvatarUrl = "";
    this.iStartTime = 0;
    this.iEndTime = 0;
    this.iSourceType = 0;
    this.bIsCameraOpen = false;
    this.bIsRoomSecret = false;
    this.sVideoCaptureUrl = "";
    this.iCdnAttendee = 0;
    this.lYYId = 0;
    this.bCertified = false;
    this.iRecType = 0;
    this.lSignChannel = 0;
    this.sLiveDesc = "";
    this.iLevel = 0;
    this.sGameShortName = "";
    this.iGameType = 0;
    this.sPrivateHost = "";
    this.iActivityCount = 0;
    this.iStreamType = 0;
    this.iBitRate = 0;
    this.iResolution = 0;
    this.iFrameRate = 0;
    this.iIsMultiStream = 0;
    this.iExeGameId = 0;
    this.lExp = 0;
    this.sReplayHls = "";
    this.lMultiStreamFlag = 0;
    this.iScreenType = 0;
    this.iChannelType = 0;
    this.sLocation = "";
    this.iCodecType = 0;
    this.vPresenterTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.vGameTags = new Taf.Vector(new HUYA.GameLiveTag());
    this.lLiveCompatibleFlag = 0;
    this.sTraceId = "";
    this.iRoomId = 0;
};
HUYA.GameLiveInfo.prototype._clone = function () { return new HUYA.GameLiveInfo(); }
HUYA.GameLiveInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.GameLiveInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.GameLiveInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lLiveId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lChannelId);
    os.writeInt32(3, this.iShortChannel);
    os.writeInt64(4, this.lSubchannel);
    os.writeString(5, this.sSubchannelName);
    os.writeInt32(6, this.iGameId);
    os.writeString(7, this.sGameName);
    os.writeInt32(8, this.iAttendeeCount);
    os.writeInt32(9, this.eGender);
    os.writeInt32(10, this.iAid);
    os.writeString(11, this.sNick);
    os.writeString(12, this.sAvatarUrl);
    os.writeInt32(13, this.iStartTime);
    os.writeInt32(14, this.iEndTime);
    os.writeInt32(15, this.iSourceType);
    os.writeBoolean(16, this.bIsCameraOpen);
    os.writeBoolean(17, this.bIsRoomSecret);
    os.writeString(18, this.sVideoCaptureUrl);
    os.writeInt32(19, this.iCdnAttendee);
    os.writeInt64(20, this.lYYId);
    os.writeBoolean(21, this.bCertified);
    os.writeInt32(22, this.iRecType);
    os.writeInt64(23, this.lSignChannel);
    os.writeString(24, this.sLiveDesc);
    os.writeInt32(25, this.iLevel);
    os.writeString(26, this.sGameShortName);
    os.writeInt32(27, this.iGameType);
    os.writeString(28, this.sPrivateHost);
    os.writeInt32(29, this.iActivityCount);
    os.writeInt32(30, this.iStreamType);
    os.writeInt32(31, this.iBitRate);
    os.writeInt32(32, this.iResolution);
    os.writeInt32(33, this.iFrameRate);
    os.writeInt32(34, this.iIsMultiStream);
    os.writeInt32(35, this.iExeGameId);
    os.writeInt64(36, this.lExp);
    os.writeString(37, this.sReplayHls);
    os.writeInt64(38, this.lMultiStreamFlag);
    os.writeInt32(39, this.iScreenType);
    os.writeInt32(40, this.iChannelType);
    os.writeString(41, this.sLocation);
    os.writeInt32(42, this.iCodecType);
    os.writeVector(43, this.vPresenterTags);
    os.writeVector(44, this.vGameTags);
    os.writeInt64(45, this.lLiveCompatibleFlag);
    os.writeString(46, this.sTraceId);
    os.writeInt32(47, this.iRoomId);
};

HUYA.GameLiveInfo.prototype.readFrom = function (is)
{
    this.lLiveId= is.readInt64(0, false, this.lLiveId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lChannelId= is.readInt64(2, false, this.lChannelId);
    this.iShortChannel= is.readInt32(3, false, this.iShortChannel);
    this.lSubchannel= is.readInt64(4, false, this.lSubchannel);
    this.sSubchannelName= is.readString(5, false, this.sSubchannelName);
    this.iGameId= is.readInt32(6, false, this.iGameId);
    this.sGameName= is.readString(7, false, this.sGameName);
    this.iAttendeeCount= is.readInt32(8, false, this.iAttendeeCount);
    this.eGender= is.readInt32(9, false, this.eGender);
    this.iAid= is.readInt32(10, false, this.iAid);
    this.sNick= is.readString(11, false, this.sNick);
    this.sAvatarUrl= is.readString(12, false, this.sAvatarUrl);
    this.iStartTime= is.readInt32(13, false, this.iStartTime);
    this.iEndTime= is.readInt32(14, false, this.iEndTime);
    this.iSourceType= is.readInt32(15, false, this.iSourceType);
    this.bIsCameraOpen= is.readBoolean(16, false, this.bIsCameraOpen);
    this.bIsRoomSecret= is.readBoolean(17, false, this.bIsRoomSecret);
    this.sVideoCaptureUrl= is.readString(18, false, this.sVideoCaptureUrl);
    this.iCdnAttendee= is.readInt32(19, false, this.iCdnAttendee);
    this.lYYId= is.readInt64(20, false, this.lYYId);
    this.bCertified= is.readBoolean(21, false, this.bCertified);
    this.iRecType= is.readInt32(22, false, this.iRecType);
    this.lSignChannel= is.readInt64(23, false, this.lSignChannel);
    this.sLiveDesc= is.readString(24, false, this.sLiveDesc);
    this.iLevel= is.readInt32(25, false, this.iLevel);
    this.sGameShortName= is.readString(26, false, this.sGameShortName);
    this.iGameType= is.readInt32(27, false, this.iGameType);
    this.sPrivateHost= is.readString(28, false, this.sPrivateHost);
    this.iActivityCount= is.readInt32(29, false, this.iActivityCount);
    this.iStreamType= is.readInt32(30, false, this.iStreamType);
    this.iBitRate= is.readInt32(31, false, this.iBitRate);
    this.iResolution= is.readInt32(32, false, this.iResolution);
    this.iFrameRate= is.readInt32(33, false, this.iFrameRate);
    this.iIsMultiStream= is.readInt32(34, false, this.iIsMultiStream);
    this.iExeGameId= is.readInt32(35, false, this.iExeGameId);
    this.lExp= is.readInt64(36, false, this.lExp);
    this.sReplayHls= is.readString(37, false, this.sReplayHls);
    this.lMultiStreamFlag= is.readInt64(38, false, this.lMultiStreamFlag);
    this.iScreenType= is.readInt32(39, false, this.iScreenType);
    this.iChannelType= is.readInt32(40, false, this.iChannelType);
    this.sLocation= is.readString(41, false, this.sLocation);
    this.iCodecType= is.readInt32(42, false, this.iCodecType);
    this.vPresenterTags= is.readVector(43, false, this.vPresenterTags);
    this.vGameTags= is.readVector(44, false, this.vGameTags);
    this.lLiveCompatibleFlag= is.readInt64(45, false, this.lLiveCompatibleFlag);
    this.sTraceId= is.readString(46, false, this.sTraceId);
    this.iRoomId= is.readInt32(47, false, this.iRoomId);
};

HUYA.BadgeInfo = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.sPresenterNickName = "";
    this.sBadgeName = "";
    this.iBadgeLevel = 0;
    this.iRank = 0;
    this.iScore = 0;
    this.iNextScore = 0;
    this.iQuotaUsed = 0;
    this.iQuota = 0;
    this.lQuotaTS = 0;
    this.lOpenTS = 0;
    this.iVFlag = 0;
    this.sVLogo = "";
    this.tChannelInfo = new HUYA.PresenterChannelInfo();
    this.sPresenterLogo = "";
    this.lVExpiredTS = 0;
    this.iBadgeType = 0;
    this.tFaithInfo = new HUYA.FaithInfo();
    this.tSuperFansInfo = new HUYA.SuperFansInfo();
    this.iBaseQuota = 0;
    this.lVConsumRank = 0;
};
HUYA.BadgeInfo.prototype._clone = function () { return new HUYA.BadgeInfo(); }
HUYA.BadgeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeString(2, this.sPresenterNickName);
    os.writeString(3, this.sBadgeName);
    os.writeInt32(4, this.iBadgeLevel);
    os.writeInt32(5, this.iRank);
    os.writeInt32(6, this.iScore);
    os.writeInt32(7, this.iNextScore);
    os.writeInt32(8, this.iQuotaUsed);
    os.writeInt32(9, this.iQuota);
    os.writeInt64(10, this.lQuotaTS);
    os.writeInt64(11, this.lOpenTS);
    os.writeInt32(12, this.iVFlag);
    os.writeString(13, this.sVLogo);
    os.writeStruct(14, this.tChannelInfo);
    os.writeString(15, this.sPresenterLogo);
    os.writeInt64(16, this.lVExpiredTS);
    os.writeInt32(17, this.iBadgeType);
    os.writeStruct(18, this.tFaithInfo);
    os.writeStruct(19, this.tSuperFansInfo);
    os.writeInt32(20, this.iBaseQuota);
    os.writeInt64(21, this.lVConsumRank);
};

HUYA.BadgeInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.sPresenterNickName= is.readString(2, false, this.sPresenterNickName);
    this.sBadgeName= is.readString(3, false, this.sBadgeName);
    this.iBadgeLevel= is.readInt32(4, false, this.iBadgeLevel);
    this.iRank= is.readInt32(5, false, this.iRank);
    this.iScore= is.readInt32(6, false, this.iScore);
    this.iNextScore= is.readInt32(7, false, this.iNextScore);
    this.iQuotaUsed= is.readInt32(8, false, this.iQuotaUsed);
    this.iQuota= is.readInt32(9, false, this.iQuota);
    this.lQuotaTS= is.readInt64(10, false, this.lQuotaTS);
    this.lOpenTS= is.readInt64(11, false, this.lOpenTS);
    this.iVFlag= is.readInt32(12, false, this.iVFlag);
    this.sVLogo= is.readString(13, false, this.sVLogo);
    this.tChannelInfo= is.readStruct(14, false, this.tChannelInfo);
    this.sPresenterLogo= is.readString(15, false, this.sPresenterLogo);
    this.lVExpiredTS= is.readInt64(16, false, this.lVExpiredTS);
    this.iBadgeType= is.readInt32(17, false, this.iBadgeType);
    this.tFaithInfo= is.readStruct(18, false, this.tFaithInfo);
    this.tSuperFansInfo= is.readStruct(19, false, this.tSuperFansInfo);
    this.iBaseQuota= is.readInt32(20, false, this.iBaseQuota);
    this.lVConsumRank= is.readInt64(21, false, this.lVConsumRank);
};

HUYA.ActivityTimeEventType = function()
{
    this.iIgnoreIfExists = 0;
    this.iBroadcastTrigger = 0;
    this.iPeriod = 0;
};
HUYA.ActivityTimeEventType.prototype._clone = function () { return new HUYA.ActivityTimeEventType(); }
HUYA.ActivityTimeEventType.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEventType.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEventType.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iIgnoreIfExists);
    os.writeInt32(1, this.iBroadcastTrigger);
    os.writeInt32(2, this.iPeriod);
};

HUYA.ActivityTimeEventType.prototype.readFrom = function (is)
{
    this.iIgnoreIfExists= is.readInt32(0, false, this.iIgnoreIfExists);
    this.iBroadcastTrigger= is.readInt32(1, false, this.iBroadcastTrigger);
    this.iPeriod= is.readInt32(2, false, this.iPeriod);
};

HUYA.ActivityTimeEventCBData = function()
{
    this.lTid = 0;
    this.lSid = 0;
    this.sReserved = "";
    this.lHashCode = -1;
};
HUYA.ActivityTimeEventCBData.prototype._clone = function () { return new HUYA.ActivityTimeEventCBData(); }
HUYA.ActivityTimeEventCBData.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEventCBData.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEventCBData.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTid);
    os.writeInt64(1, this.lSid);
    os.writeString(2, this.sReserved);
    os.writeInt64(3, this.lHashCode);
};

HUYA.ActivityTimeEventCBData.prototype.readFrom = function (is)
{
    this.lTid= is.readInt64(0, false, this.lTid);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.sReserved= is.readString(2, false, this.sReserved);
    this.lHashCode= is.readInt64(3, false, this.lHashCode);
};

HUYA.ActivitySerializedMsg = function()
{
    this.iSubUri = 0;
    this.vContent = new Taf.BinBuffer();
};
HUYA.ActivitySerializedMsg.prototype._clone = function () { return new HUYA.ActivitySerializedMsg(); }
HUYA.ActivitySerializedMsg.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivitySerializedMsg.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivitySerializedMsg.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iSubUri);
    os.writeBytes(1, this.vContent);
};

HUYA.ActivitySerializedMsg.prototype.readFrom = function (is)
{
    this.iSubUri= is.readInt32(0, false, this.iSubUri);
    this.vContent= is.readBytes(1, false, this.vContent);
};

HUYA.ACOrderInfo = function()
{
    this.tMTInfo = new HUYA.UserBase();
    this.tCTInfo = new HUYA.UserBase();
    this.tSkillInfo = new HUYA.AccompanyMasterSkillDetail();
    this.tOrderBase = new HUYA.ACOrderBase();
    this.tComplainInfo = new HUYA.ACComplainInfo();
    this.sToast = "";
    this.sJumpMsg = "";
    this.sSignChannel = "";
    this.sSignChannelName = "";
    this.vNext = new Taf.Vector(new Taf.INT32());
    this.tDes = new HUYA.ACOrderDes();
    this.tLevel = new HUYA.MasterLevelBase();
    this.tContext = new HUYA.ACOrderContext();
};
HUYA.ACOrderInfo.prototype._clone = function () { return new HUYA.ACOrderInfo(); }
HUYA.ACOrderInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACOrderInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACOrderInfo.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tMTInfo);
    os.writeStruct(1, this.tCTInfo);
    os.writeStruct(2, this.tSkillInfo);
    os.writeStruct(3, this.tOrderBase);
    os.writeStruct(4, this.tComplainInfo);
    os.writeString(5, this.sToast);
    os.writeString(6, this.sJumpMsg);
    os.writeString(7, this.sSignChannel);
    os.writeString(8, this.sSignChannelName);
    os.writeVector(9, this.vNext);
    os.writeStruct(10, this.tDes);
    os.writeStruct(11, this.tLevel);
    os.writeStruct(12, this.tContext);
};

HUYA.ACOrderInfo.prototype.readFrom = function (is)
{
    this.tMTInfo= is.readStruct(0, false, this.tMTInfo);
    this.tCTInfo= is.readStruct(1, false, this.tCTInfo);
    this.tSkillInfo= is.readStruct(2, false, this.tSkillInfo);
    this.tOrderBase= is.readStruct(3, false, this.tOrderBase);
    this.tComplainInfo= is.readStruct(4, false, this.tComplainInfo);
    this.sToast= is.readString(5, false, this.sToast);
    this.sJumpMsg= is.readString(6, false, this.sJumpMsg);
    this.sSignChannel= is.readString(7, false, this.sSignChannel);
    this.sSignChannelName= is.readString(8, false, this.sSignChannelName);
    this.vNext= is.readVector(9, false, this.vNext);
    this.tDes= is.readStruct(10, false, this.tDes);
    this.tLevel= is.readStruct(11, false, this.tLevel);
    this.tContext= is.readStruct(12, false, this.tContext);
};

HUYA.VipInfoChangedReq = function()
{
    this.iVipType = 0;
    this.lUid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.lPid = 0;
    this.lLevel = 0;
    this.sSerializeData = "";
};
HUYA.VipInfoChangedReq.prototype._clone = function () { return new HUYA.VipInfoChangedReq(); }
HUYA.VipInfoChangedReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.VipInfoChangedReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.VipInfoChangedReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iVipType);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lTid);
    os.writeInt64(3, this.lSid);
    os.writeInt64(4, this.lPid);
    os.writeInt64(5, this.lLevel);
    os.writeString(6, this.sSerializeData);
};

HUYA.VipInfoChangedReq.prototype.readFrom = function (is)
{
    this.iVipType= is.readInt32(0, false, this.iVipType);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lTid= is.readInt64(2, false, this.lTid);
    this.lSid= is.readInt64(3, false, this.lSid);
    this.lPid= is.readInt64(4, false, this.lPid);
    this.lLevel= is.readInt64(5, false, this.lLevel);
    this.sSerializeData= is.readString(6, false, this.sSerializeData);
};

HUYA.SendItemEdgeEventReq = function()
{
    this.tId = new HUYA.UserId();
    this.lSid = 0;
    this.lSubSid = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lPresenterUid = 0;
    this.sPayId = "";
    this.sSenderNick = "";
    this.sPresenterNick = "";
    this.iItemCountByGroup = 0;
    this.iItemGroup = 0;
    this.iSuperPupleLevel = 0;
    this.iFromType = 0;
    this.iPayType = 0;
    this.iTemplateType = 0;
    this.iTotalPay = 0;
    this.sExpand = "";
    this.iIsGroup = 0;
    this.bWorldBanner = true;
    this.iEffectType = 0;
    this.iColorEffectType = 0;
    this.iWeekStart = 0;
    this.lPayTime = 0;
    this.lGameId = 0;
    this.iItemEventType = 0;
    this.sItemEventContent = "";
    this.sSenderIcon = "";
    this.sPresenterIcon = "";
    this.lRoomId = 0;
    this.lHomeOwnerUid = 0;
    this.lLiveId = 0;
    this.lMicUid = 0;
};
HUYA.SendItemEdgeEventReq.prototype._clone = function () { return new HUYA.SendItemEdgeEventReq(); }
HUYA.SendItemEdgeEventReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.SendItemEdgeEventReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.SendItemEdgeEventReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lSid);
    os.writeInt64(2, this.lSubSid);
    os.writeInt32(3, this.iItemType);
    os.writeInt32(4, this.iItemCount);
    os.writeInt64(5, this.lPresenterUid);
    os.writeString(6, this.sPayId);
    os.writeString(7, this.sSenderNick);
    os.writeString(8, this.sPresenterNick);
    os.writeInt32(9, this.iItemCountByGroup);
    os.writeInt32(10, this.iItemGroup);
    os.writeInt32(11, this.iSuperPupleLevel);
    os.writeInt32(12, this.iFromType);
    os.writeInt32(13, this.iPayType);
    os.writeInt32(14, this.iTemplateType);
    os.writeInt32(15, this.iTotalPay);
    os.writeString(16, this.sExpand);
    os.writeInt16(17, this.iIsGroup);
    os.writeBoolean(18, this.bWorldBanner);
    os.writeInt32(19, this.iEffectType);
    os.writeInt32(20, this.iColorEffectType);
    os.writeInt16(21, this.iWeekStart);
    os.writeInt64(22, this.lPayTime);
    os.writeInt64(23, this.lGameId);
    os.writeInt16(24, this.iItemEventType);
    os.writeString(25, this.sItemEventContent);
    os.writeString(26, this.sSenderIcon);
    os.writeString(27, this.sPresenterIcon);
    os.writeInt64(28, this.lRoomId);
    os.writeInt64(29, this.lHomeOwnerUid);
    os.writeInt64(30, this.lLiveId);
    os.writeInt64(31, this.lMicUid);
};

HUYA.SendItemEdgeEventReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lSid= is.readInt64(1, false, this.lSid);
    this.lSubSid= is.readInt64(2, false, this.lSubSid);
    this.iItemType= is.readInt32(3, false, this.iItemType);
    this.iItemCount= is.readInt32(4, false, this.iItemCount);
    this.lPresenterUid= is.readInt64(5, false, this.lPresenterUid);
    this.sPayId= is.readString(6, false, this.sPayId);
    this.sSenderNick= is.readString(7, false, this.sSenderNick);
    this.sPresenterNick= is.readString(8, false, this.sPresenterNick);
    this.iItemCountByGroup= is.readInt32(9, false, this.iItemCountByGroup);
    this.iItemGroup= is.readInt32(10, false, this.iItemGroup);
    this.iSuperPupleLevel= is.readInt32(11, false, this.iSuperPupleLevel);
    this.iFromType= is.readInt32(12, false, this.iFromType);
    this.iPayType= is.readInt32(13, false, this.iPayType);
    this.iTemplateType= is.readInt32(14, false, this.iTemplateType);
    this.iTotalPay= is.readInt32(15, false, this.iTotalPay);
    this.sExpand= is.readString(16, false, this.sExpand);
    this.iIsGroup= is.readInt16(17, false, this.iIsGroup);
    this.bWorldBanner= is.readBoolean(18, false, this.bWorldBanner);
    this.iEffectType= is.readInt32(19, false, this.iEffectType);
    this.iColorEffectType= is.readInt32(20, false, this.iColorEffectType);
    this.iWeekStart= is.readInt16(21, false, this.iWeekStart);
    this.lPayTime= is.readInt64(22, false, this.lPayTime);
    this.lGameId= is.readInt64(23, false, this.lGameId);
    this.iItemEventType= is.readInt16(24, false, this.iItemEventType);
    this.sItemEventContent= is.readString(25, false, this.sItemEventContent);
    this.sSenderIcon= is.readString(26, false, this.sSenderIcon);
    this.sPresenterIcon= is.readString(27, false, this.sPresenterIcon);
    this.lRoomId= is.readInt64(28, false, this.lRoomId);
    this.lHomeOwnerUid= is.readInt64(29, false, this.lHomeOwnerUid);
    this.lLiveId= is.readInt64(30, false, this.lLiveId);
    this.lMicUid= is.readInt64(31, false, this.lMicUid);
};

HUYA.H5ExternalFilterRsp = function()
{
    this.iRetCode = 0;
};
HUYA.H5ExternalFilterRsp.prototype._clone = function () { return new HUYA.H5ExternalFilterRsp(); }
HUYA.H5ExternalFilterRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.H5ExternalFilterRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.H5ExternalFilterRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRetCode);
};

HUYA.H5ExternalFilterRsp.prototype.readFrom = function (is)
{
    this.iRetCode= is.readInt32(0, false, this.iRetCode);
};

HUYA.H5ExternalFilterReq = function()
{
    this.tId = new HUYA.UserId();
    this.lPid = 0;
    this.iGameId = 0;
    this.iActId = 0;
    this.lHideURI = 0;
};
HUYA.H5ExternalFilterReq.prototype._clone = function () { return new HUYA.H5ExternalFilterReq(); }
HUYA.H5ExternalFilterReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.H5ExternalFilterReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.H5ExternalFilterReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iGameId);
    os.writeInt32(3, this.iActId);
    os.writeInt64(4, this.lHideURI);
};

HUYA.H5ExternalFilterReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iGameId= is.readInt32(2, false, this.iGameId);
    this.iActId= is.readInt32(3, false, this.iActId);
    this.lHideURI= is.readInt64(4, false, this.lHideURI);
};

HUYA.EndLiveEventNotifyReq = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.iReason = 0;
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
};
HUYA.EndLiveEventNotifyReq.prototype._clone = function () { return new HUYA.EndLiveEventNotifyReq(); }
HUYA.EndLiveEventNotifyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.EndLiveEventNotifyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.EndLiveEventNotifyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeInt32(1, this.iReason);
    os.writeStruct(2, this.tGameLiveMisc);
};

HUYA.EndLiveEventNotifyReq.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.iReason= is.readInt32(1, false, this.iReason);
    this.tGameLiveMisc= is.readStruct(2, false, this.tGameLiveMisc);
};

HUYA.BeginLiveEventNotifyReq = function()
{
    this.tGameLiveInfo = new HUYA.GameLiveInfo();
    this.tGameLiveMisc = new HUYA.GameLiveMisc();
};
HUYA.BeginLiveEventNotifyReq.prototype._clone = function () { return new HUYA.BeginLiveEventNotifyReq(); }
HUYA.BeginLiveEventNotifyReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BeginLiveEventNotifyReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BeginLiveEventNotifyReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tGameLiveInfo);
    os.writeStruct(1, this.tGameLiveMisc);
};

HUYA.BeginLiveEventNotifyReq.prototype.readFrom = function (is)
{
    this.tGameLiveInfo= is.readStruct(0, false, this.tGameLiveInfo);
    this.tGameLiveMisc= is.readStruct(1, false, this.tGameLiveMisc);
};

HUYA.BadgeUpdated = function()
{
    this.lUid = 0;
    this.lBadgeId = 0;
    this.tOriginalInfo = new HUYA.BadgeInfo();
    this.tInfo = new HUYA.BadgeInfo();
    this.iItemType = 0;
};
HUYA.BadgeUpdated.prototype._clone = function () { return new HUYA.BadgeUpdated(); }
HUYA.BadgeUpdated.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.BadgeUpdated.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.BadgeUpdated.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lBadgeId);
    os.writeStruct(2, this.tOriginalInfo);
    os.writeStruct(3, this.tInfo);
    os.writeInt32(4, this.iItemType);
};

HUYA.BadgeUpdated.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lBadgeId= is.readInt64(1, false, this.lBadgeId);
    this.tOriginalInfo= is.readStruct(2, false, this.tOriginalInfo);
    this.tInfo= is.readStruct(3, false, this.tInfo);
    this.iItemType= is.readInt32(4, false, this.iItemType);
};

HUYA.ActivityTimeEvent = function()
{
    this.iActivityId = 0;
    this.lUid = 0;
    this.iEventId = 0;
    this.iTriggerDelay = 0;
    this.tType = new HUYA.ActivityTimeEventType();
    this.tCallBackData = new HUYA.ActivityTimeEventCBData();
};
HUYA.ActivityTimeEvent.prototype._clone = function () { return new HUYA.ActivityTimeEvent(); }
HUYA.ActivityTimeEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityTimeEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityTimeEvent.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iActivityId);
    os.writeInt64(1, this.lUid);
    os.writeInt32(2, this.iEventId);
    os.writeInt32(3, this.iTriggerDelay);
    os.writeStruct(4, this.tType);
    os.writeStruct(5, this.tCallBackData);
};

HUYA.ActivityTimeEvent.prototype.readFrom = function (is)
{
    this.iActivityId= is.readInt32(0, false, this.iActivityId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.iEventId= is.readInt32(2, false, this.iEventId);
    this.iTriggerDelay= is.readInt32(3, false, this.iTriggerDelay);
    this.tType= is.readStruct(4, false, this.tType);
    this.tCallBackData= is.readStruct(5, false, this.tCallBackData);
};

HUYA.ActivityMsgRsp = function()
{
    this.iEnable = 0;
    this.vSerializedMsg = new Taf.Vector(new HUYA.ActivitySerializedMsg());
    this.iTimeStamp = 0;
};
HUYA.ActivityMsgRsp.prototype._clone = function () { return new HUYA.ActivityMsgRsp(); }
HUYA.ActivityMsgRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityMsgRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityMsgRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iEnable);
    os.writeVector(1, this.vSerializedMsg);
    os.writeInt32(2, this.iTimeStamp);
};

HUYA.ActivityMsgRsp.prototype.readFrom = function (is)
{
    this.iEnable= is.readInt32(0, false, this.iEnable);
    this.vSerializedMsg= is.readVector(1, false, this.vSerializedMsg);
    this.iTimeStamp= is.readInt32(2, false, this.iTimeStamp);
};

HUYA.ActivityMsgReq = function()
{
    this.tUserId = new HUYA.UserId();
    this.iActivityId = 0;
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iChannelType = 0;
    this.iSubUri = 0;
};
HUYA.ActivityMsgReq.prototype._clone = function () { return new HUYA.ActivityMsgReq(); }
HUYA.ActivityMsgReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ActivityMsgReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ActivityMsgReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUserId);
    os.writeInt32(1, this.iActivityId);
    os.writeInt64(2, this.lPid);
    os.writeInt64(3, this.lTid);
    os.writeInt64(4, this.lSid);
    os.writeInt32(5, this.iChannelType);
    os.writeInt32(6, this.iSubUri);
};

HUYA.ActivityMsgReq.prototype.readFrom = function (is)
{
    this.tUserId= is.readStruct(0, false, this.tUserId);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.lTid= is.readInt64(3, false, this.lTid);
    this.lSid= is.readInt64(4, false, this.lSid);
    this.iChannelType= is.readInt32(5, false, this.iChannelType);
    this.iSubUri= is.readInt32(6, false, this.iSubUri);
};

HUYA.ACOrderEvent = function()
{
    this.tInfo = new HUYA.ACOrderInfo();
};
HUYA.ACOrderEvent.prototype._clone = function () { return new HUYA.ACOrderEvent(); }
HUYA.ACOrderEvent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.ACOrderEvent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.ACOrderEvent.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tInfo);
};

HUYA.ACOrderEvent.prototype.readFrom = function (is)
{
    this.tInfo= is.readStruct(0, false, this.tInfo);
};

var ActPK = ActPK || {};


ActPK.ActPKUpdateInfo = function()
{
    this.lUid = 0;
    this.lPid = 0;
    this.iItemType = 0;
    this.iItemCount = 0;
    this.lScore = 0;
    this.bIsOrder = false;
    this.iBroadcast = 0;
    this.lMicUid = 0;
};
ActPK.ActPKUpdateInfo.prototype._clone = function () { return new ActPK.ActPKUpdateInfo(); }
ActPK.ActPKUpdateInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKUpdateInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKUpdateInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iItemType);
    os.writeInt32(3, this.iItemCount);
    os.writeInt64(4, this.lScore);
    os.writeBoolean(5, this.bIsOrder);
    os.writeInt32(6, this.iBroadcast);
    os.writeInt64(7, this.lMicUid);
};

ActPK.ActPKUpdateInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iItemType= is.readInt32(2, false, this.iItemType);
    this.iItemCount= is.readInt32(3, false, this.iItemCount);
    this.lScore= is.readInt64(4, false, this.lScore);
    this.bIsOrder= is.readBoolean(5, false, this.bIsOrder);
    this.iBroadcast= is.readInt32(6, false, this.iBroadcast);
    this.lMicUid= is.readInt64(7, false, this.lMicUid);
};


ActPK.ActPKInfo = function()
{
    this.lActId = 0;
    this.lPKId = 0;
    this.iType = 0;
    this.iArea = 0;
    this.lAttPid = 0;
    this.lAttScore = 0;
    this.lDefPid = 0;
    this.lDefScore = 0;
    this.iBeginTime = 0;
    this.iEndTime = 0;
    this.iKillTime = 0;
    this.iState = 0;
    this.lAttReward = 0;
    this.lDefReward = 0;
    this.lFlag = 0;
    this.lFlag2 = 0;
    this.lGameId = 0;
    this.lAttPKBuff = 0;
    this.lDefPKBuff = 0;
    this.sUserCustom = "";
    this.iLeftCDTime = 0;
    this.iLeftGuardTime = 0;
};
ActPK.ActPKInfo.prototype._clone = function () { return new ActPK.ActPKInfo(); }
ActPK.ActPKInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActPK.ActPKInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActPK.ActPKInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lActId);
    os.writeInt64(1, this.lPKId);
    os.writeInt32(2, this.iType);
    os.writeInt32(3, this.iArea);
    os.writeInt64(4, this.lAttPid);
    os.writeInt64(5, this.lAttScore);
    os.writeInt64(6, this.lDefPid);
    os.writeInt64(7, this.lDefScore);
    os.writeInt32(8, this.iBeginTime);
    os.writeInt32(9, this.iEndTime);
    os.writeInt32(10, this.iKillTime);
    os.writeInt32(11, this.iState);
    os.writeInt64(12, this.lAttReward);
    os.writeInt64(13, this.lDefReward);
    os.writeInt64(14, this.lFlag);
    os.writeInt64(15, this.lFlag2);
    os.writeInt64(16, this.lGameId);
    os.writeInt64(17, this.lAttPKBuff);
    os.writeInt64(18, this.lDefPKBuff);
    os.writeString(19, this.sUserCustom);
    os.writeInt32(20, this.iLeftCDTime);
    os.writeInt32(21, this.iLeftGuardTime);
};

ActPK.ActPKInfo.prototype.readFrom = function (is)
{
    this.lActId= is.readInt64(0, false, this.lActId);
    this.lPKId= is.readInt64(1, false, this.lPKId);
    this.iType= is.readInt32(2, false, this.iType);
    this.iArea= is.readInt32(3, false, this.iArea);
    this.lAttPid= is.readInt64(4, false, this.lAttPid);
    this.lAttScore= is.readInt64(5, false, this.lAttScore);
    this.lDefPid= is.readInt64(6, false, this.lDefPid);
    this.lDefScore= is.readInt64(7, false, this.lDefScore);
    this.iBeginTime= is.readInt32(8, false, this.iBeginTime);
    this.iEndTime= is.readInt32(9, false, this.iEndTime);
    this.iKillTime= is.readInt32(10, false, this.iKillTime);
    this.iState= is.readInt32(11, false, this.iState);
    this.lAttReward= is.readInt64(12, false, this.lAttReward);
    this.lDefReward= is.readInt64(13, false, this.lDefReward);
    this.lFlag= is.readInt64(14, false, this.lFlag);
    this.lFlag2= is.readInt64(15, false, this.lFlag2);
    this.lGameId= is.readInt64(16, false, this.lGameId);
    this.lAttPKBuff= is.readInt64(17, false, this.lAttPKBuff);
    this.lDefPKBuff= is.readInt64(18, false, this.lDefPKBuff);
    this.sUserCustom= is.readString(19, false, this.sUserCustom);
    this.iLeftCDTime= is.readInt32(20, false, this.iLeftCDTime);
    this.iLeftGuardTime= is.readInt32(21, false, this.iLeftGuardTime);
};

var ActDocor = ActDocor || {};


ActDocor.GmMessageReq = function()
{
    this.iCmdId = 0;
    this.lUid = 0;
    this.lPid = 0;
    this.sContent = "";
};
ActDocor.GmMessageReq.prototype._clone = function () { return new ActDocor.GmMessageReq(); }
ActDocor.GmMessageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActDocor.GmMessageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActDocor.GmMessageReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCmdId);
    os.writeInt64(1, this.lUid);
    os.writeInt64(2, this.lPid);
    os.writeString(3, this.sContent);
};

ActDocor.GmMessageReq.prototype.readFrom = function (is)
{
    this.iCmdId= is.readInt32(0, false, this.iCmdId);
    this.lUid= is.readInt64(1, false, this.lUid);
    this.lPid= is.readInt64(2, false, this.lPid);
    this.sContent= is.readString(3, false, this.sContent);
};

var ActGuildAllStar = ActGuildAllStar || {};


ActGuildAllStar.TemplateURI = 
{
    PushAnchorPanel: 2020111501,
    PushAnchorUpdatePanel: 2020111502,
    PushStageResultPanel: 2020111503,
    PushFinalResultPanel: 2020111504,
    PushHourRankPanel: 2020111505,
    PushUnionRankPanel: 2020111506,
    PushReviveRankPanel: 2020111507,
    PushAnchorRankPanel: 2020111508,
    PushRichRankPanel: 2020111509,
    PushRivalPanel: 2020111510,
    PushHelpPanel: 2020111511,
    PushBattleAnnouncePanel: 2020111512,
    PushBattleUpdatePanel: 2020111513,
    PushBattlePanel: 2020111514,
    PushBattleResultPanel: 2020111515,
    PushBattleFansScorePanel: 2020111516,
    PushTaskUpdate: 2020111530,
    PushTaskItemUpdate: 2020111531,
    PushHidePanel: 2020111599
};

ActGuildAllStar.STAGE = 
{
    kBeforeActivityStage: 0,
    kAuditionStage: 1,
    kSecondStage: 2,
    kThirdStage: 3,
    kFinalStage: 4,
    kHonorStage: 5
};

ActGuildAllStar.RankAreaURI = 
{
    kGame: 1,
    kEntertainment: 2,
    kStar: 3,
    kFace: 4,
    kGold: 5
};

ActGuildAllStar.RankTypeURI = 
{
    kHourRank: 1,
    kUnionRank: 2,
    kAnchorRank: 3,
    kRichRank: 4
};

ActGuildAllStar.TaskState = 
{
    E_TaskState_Doing: 0,
    E_TaskState_Done: 1
};

ActGuildAllStar.TaskId = 
{
    E_TaskId_Pk: 1000
};

ActGuildAllStar.TaskLevel = 
{
    E_TaskLevel_B: 1,
    E_TaskLevel_A: 2,
    E_TaskLevel_S: 3,
    E_TaskLevel_SS: 4
};

ActGuildAllStar.AwardType = 
{
    E_AwardType_StarLightVal: 1,
    E_AwardType_AddPopular: 2,
    E_AwardType_PkTime: 3,
    E_AwardType_SuperFansRight: 4,
    E_AwardType_DFansLevelUp: 5
};

ActGuildAllStar.JumpChannel = function()
{
    this.lPid = 0;
    this.lTid = 0;
    this.lSid = 0;
    this.iGameId = 0;
    this.lYYId = 0;
    this.iRoomId = 0;
    this.iLive = 0;
};
ActGuildAllStar.JumpChannel.prototype._clone = function () { return new ActGuildAllStar.JumpChannel(); }
ActGuildAllStar.JumpChannel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.JumpChannel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.JumpChannel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTid);
    os.writeInt64(2, this.lSid);
    os.writeInt32(3, this.iGameId);
    os.writeInt64(4, this.lYYId);
    os.writeInt32(5, this.iRoomId);
    os.writeInt32(6, this.iLive);
};

ActGuildAllStar.JumpChannel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTid= is.readInt64(1, false, this.lTid);
    this.lSid= is.readInt64(2, false, this.lSid);
    this.iGameId= is.readInt32(3, false, this.iGameId);
    this.lYYId= is.readInt64(4, false, this.lYYId);
    this.iRoomId= is.readInt32(5, false, this.iRoomId);
    this.iLive= is.readInt32(6, false, this.iLive);
};

ActGuildAllStar.AnchorUpdatePanel = function()
{
    this.iHourRank = 0;
    this.lHourScore = 0;
    this.iUnionRank = 0;
    this.lUnionScore = 0;
    this.iAnchorRank = 0;
    this.lAnchorScore = 0;
    this.iPromoteTag = 0;
    this.iBuff = 0;
    this.iBuffEndTime = 0;
    this.lPid = 0;
    this.iStageAnchorRank = 0;
    this.lStageAnchorScore = 0;
};
ActGuildAllStar.AnchorUpdatePanel.prototype._clone = function () { return new ActGuildAllStar.AnchorUpdatePanel(); }
ActGuildAllStar.AnchorUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AnchorUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AnchorUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iHourRank);
    os.writeInt64(1, this.lHourScore);
    os.writeInt32(2, this.iUnionRank);
    os.writeInt64(3, this.lUnionScore);
    os.writeInt32(4, this.iAnchorRank);
    os.writeInt64(5, this.lAnchorScore);
    os.writeInt32(6, this.iPromoteTag);
    os.writeInt32(7, this.iBuff);
    os.writeInt32(8, this.iBuffEndTime);
    os.writeInt64(9, this.lPid);
    os.writeInt32(10, this.iStageAnchorRank);
    os.writeInt64(11, this.lStageAnchorScore);
};

ActGuildAllStar.AnchorUpdatePanel.prototype.readFrom = function (is)
{
    this.iHourRank= is.readInt32(0, false, this.iHourRank);
    this.lHourScore= is.readInt64(1, false, this.lHourScore);
    this.iUnionRank= is.readInt32(2, false, this.iUnionRank);
    this.lUnionScore= is.readInt64(3, false, this.lUnionScore);
    this.iAnchorRank= is.readInt32(4, false, this.iAnchorRank);
    this.lAnchorScore= is.readInt64(5, false, this.lAnchorScore);
    this.iPromoteTag= is.readInt32(6, false, this.iPromoteTag);
    this.iBuff= is.readInt32(7, false, this.iBuff);
    this.iBuffEndTime= is.readInt32(8, false, this.iBuffEndTime);
    this.lPid= is.readInt64(9, false, this.lPid);
    this.iStageAnchorRank= is.readInt32(10, false, this.iStageAnchorRank);
    this.lStageAnchorScore= is.readInt64(11, false, this.lStageAnchorScore);
};

ActGuildAllStar.AnchorPanel = function()
{
    this.tUpdate = new ActGuildAllStar.AnchorUpdatePanel();
    this.lPid = 0;
    this.iStage = 0;
    this.iArea = 0;
    this.sDesc1 = "";
    this.sDesc2 = "";
    this.sUnionName = "";
    this.sUnionLogoUrl = "";
    this.iRevive = 0;
    this.iUnionPkState = 0;
    this.iPromoteNum = 0;
    this.lUnionId = 0;
    this.sNickName = "";
    this.iAct = 0;
};
ActGuildAllStar.AnchorPanel.prototype._clone = function () { return new ActGuildAllStar.AnchorPanel(); }
ActGuildAllStar.AnchorPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AnchorPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AnchorPanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tUpdate);
    os.writeInt64(1, this.lPid);
    os.writeInt32(2, this.iStage);
    os.writeInt32(3, this.iArea);
    os.writeString(4, this.sDesc1);
    os.writeString(5, this.sDesc2);
    os.writeString(6, this.sUnionName);
    os.writeString(7, this.sUnionLogoUrl);
    os.writeInt32(8, this.iRevive);
    os.writeInt32(9, this.iUnionPkState);
    os.writeInt32(10, this.iPromoteNum);
    os.writeInt64(11, this.lUnionId);
    os.writeString(12, this.sNickName);
    os.writeInt32(13, this.iAct);
};

ActGuildAllStar.AnchorPanel.prototype.readFrom = function (is)
{
    this.tUpdate= is.readStruct(0, false, this.tUpdate);
    this.lPid= is.readInt64(1, false, this.lPid);
    this.iStage= is.readInt32(2, false, this.iStage);
    this.iArea= is.readInt32(3, false, this.iArea);
    this.sDesc1= is.readString(4, false, this.sDesc1);
    this.sDesc2= is.readString(5, false, this.sDesc2);
    this.sUnionName= is.readString(6, false, this.sUnionName);
    this.sUnionLogoUrl= is.readString(7, false, this.sUnionLogoUrl);
    this.iRevive= is.readInt32(8, false, this.iRevive);
    this.iUnionPkState= is.readInt32(9, false, this.iUnionPkState);
    this.iPromoteNum= is.readInt32(10, false, this.iPromoteNum);
    this.lUnionId= is.readInt64(11, false, this.lUnionId);
    this.sNickName= is.readString(12, false, this.sNickName);
    this.iAct= is.readInt32(13, false, this.iAct);
};

ActGuildAllStar.StageResultPanel = function()
{
    this.lPid = 0;
    this.iStage = 0;
    this.sStage = "";
    this.iPromote = 0;
    this.sUnionName = "";
    this.sUnionLogoUrl = "";
    this.sDesc1 = "";
    this.sDesc2 = "";
    this.iAct = 0;
    this.iArea = 0;
};
ActGuildAllStar.StageResultPanel.prototype._clone = function () { return new ActGuildAllStar.StageResultPanel(); }
ActGuildAllStar.StageResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.StageResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.StageResultPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iStage);
    os.writeString(2, this.sStage);
    os.writeInt32(3, this.iPromote);
    os.writeString(4, this.sUnionName);
    os.writeString(5, this.sUnionLogoUrl);
    os.writeString(6, this.sDesc1);
    os.writeString(7, this.sDesc2);
    os.writeInt32(8, this.iAct);
    os.writeInt32(9, this.iArea);
};

ActGuildAllStar.StageResultPanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iStage= is.readInt32(1, false, this.iStage);
    this.sStage= is.readString(2, false, this.sStage);
    this.iPromote= is.readInt32(3, false, this.iPromote);
    this.sUnionName= is.readString(4, false, this.sUnionName);
    this.sUnionLogoUrl= is.readString(5, false, this.sUnionLogoUrl);
    this.sDesc1= is.readString(6, false, this.sDesc1);
    this.sDesc2= is.readString(7, false, this.sDesc2);
    this.iAct= is.readInt32(8, false, this.iAct);
    this.iArea= is.readInt32(9, false, this.iArea);
};

ActGuildAllStar.FinalResultItem = function()
{
    this.sUnionName = "";
    this.sUnionLogoUrl = "";
};
ActGuildAllStar.FinalResultItem.prototype._clone = function () { return new ActGuildAllStar.FinalResultItem(); }
ActGuildAllStar.FinalResultItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.FinalResultItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.FinalResultItem.prototype.writeTo = function (os)
{
    os.writeString(0, this.sUnionName);
    os.writeString(1, this.sUnionLogoUrl);
};

ActGuildAllStar.FinalResultItem.prototype.readFrom = function (is)
{
    this.sUnionName= is.readString(0, false, this.sUnionName);
    this.sUnionLogoUrl= is.readString(1, false, this.sUnionLogoUrl);
};

ActGuildAllStar.FinalResultPanel = function()
{
    this.vChampion = new Taf.Vector(new ActGuildAllStar.FinalResultItem());
    this.iArea = 0;
    this.iAct = 0;
    this.sDesc = "";
};
ActGuildAllStar.FinalResultPanel.prototype._clone = function () { return new ActGuildAllStar.FinalResultPanel(); }
ActGuildAllStar.FinalResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.FinalResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.FinalResultPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vChampion);
    os.writeInt32(1, this.iArea);
    os.writeInt32(2, this.iAct);
    os.writeString(3, this.sDesc);
};

ActGuildAllStar.FinalResultPanel.prototype.readFrom = function (is)
{
    this.vChampion= is.readVector(0, false, this.vChampion);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.iAct= is.readInt32(2, false, this.iAct);
    this.sDesc= is.readString(3, false, this.sDesc);
};

ActGuildAllStar.RankItem = function()
{
    this.lUid = 0;
    this.iRank = 0;
    this.lScore = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.tJump = new ActGuildAllStar.JumpChannel();
};
ActGuildAllStar.RankItem.prototype._clone = function () { return new ActGuildAllStar.RankItem(); }
ActGuildAllStar.RankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.RankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.RankItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sLogoUrl);
    os.writeStruct(5, this.tJump);
};

ActGuildAllStar.RankItem.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sLogoUrl= is.readString(4, false, this.sLogoUrl);
    this.tJump= is.readStruct(5, false, this.tJump);
};

ActGuildAllStar.UnionRankItem = function()
{
    this.lUnionId = 0;
    this.iRank = 0;
    this.lScore = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.vAnchorList = new Taf.Vector(new ActGuildAllStar.RankItem());
};
ActGuildAllStar.UnionRankItem.prototype._clone = function () { return new ActGuildAllStar.UnionRankItem(); }
ActGuildAllStar.UnionRankItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.UnionRankItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.UnionRankItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUnionId);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sLogoUrl);
    os.writeVector(5, this.vAnchorList);
};

ActGuildAllStar.UnionRankItem.prototype.readFrom = function (is)
{
    this.lUnionId= is.readInt64(0, false, this.lUnionId);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sLogoUrl= is.readString(4, false, this.sLogoUrl);
    this.vAnchorList= is.readVector(5, false, this.vAnchorList);
};

ActGuildAllStar.HourRankPanel = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.iArea = 0;
    this.iHour = 0;
    this.iRank = 0;
    this.lScore = 0;
};
ActGuildAllStar.HourRankPanel.prototype._clone = function () { return new ActGuildAllStar.HourRankPanel(); }
ActGuildAllStar.HourRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.HourRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.HourRankPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iArea);
    os.writeInt32(2, this.iHour);
    os.writeInt32(3, this.iRank);
    os.writeInt64(4, this.lScore);
};

ActGuildAllStar.HourRankPanel.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.iHour= is.readInt32(2, false, this.iHour);
    this.iRank= is.readInt32(3, false, this.iRank);
    this.lScore= is.readInt64(4, false, this.lScore);
};

ActGuildAllStar.UnionRankPanel = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.UnionRankItem());
    this.iArea = 0;
};
ActGuildAllStar.UnionRankPanel.prototype._clone = function () { return new ActGuildAllStar.UnionRankPanel(); }
ActGuildAllStar.UnionRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.UnionRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.UnionRankPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iArea);
};

ActGuildAllStar.UnionRankPanel.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iArea= is.readInt32(1, false, this.iArea);
};

ActGuildAllStar.ReviveRankPanel = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.UnionRankItem());
    this.iArea = 0;
};
ActGuildAllStar.ReviveRankPanel.prototype._clone = function () { return new ActGuildAllStar.ReviveRankPanel(); }
ActGuildAllStar.ReviveRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.ReviveRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.ReviveRankPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iArea);
};

ActGuildAllStar.ReviveRankPanel.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iArea= is.readInt32(1, false, this.iArea);
};

ActGuildAllStar.AnchorRankPanel = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.iArea = 0;
    this.lUnionId = 0;
};
ActGuildAllStar.AnchorRankPanel.prototype._clone = function () { return new ActGuildAllStar.AnchorRankPanel(); }
ActGuildAllStar.AnchorRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AnchorRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AnchorRankPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iArea);
    os.writeInt64(2, this.lUnionId);
};

ActGuildAllStar.AnchorRankPanel.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.lUnionId= is.readInt64(2, false, this.lUnionId);
};

ActGuildAllStar.RichRankPanel = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.iArea = 0;
    this.lUnionId = 0;
};
ActGuildAllStar.RichRankPanel.prototype._clone = function () { return new ActGuildAllStar.RichRankPanel(); }
ActGuildAllStar.RichRankPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.RichRankPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.RichRankPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iArea);
    os.writeInt64(2, this.lUnionId);
};

ActGuildAllStar.RichRankPanel.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.lUnionId= is.readInt64(2, false, this.lUnionId);
};

ActGuildAllStar.AnchorItem = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.tJump = new ActGuildAllStar.JumpChannel();
    this.iResult = 0;
};
ActGuildAllStar.AnchorItem.prototype._clone = function () { return new ActGuildAllStar.AnchorItem(); }
ActGuildAllStar.AnchorItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AnchorItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AnchorItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeStruct(3, this.tJump);
    os.writeInt32(4, this.iResult);
};

ActGuildAllStar.AnchorItem.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.tJump= is.readStruct(3, false, this.tJump);
    this.iResult= is.readInt32(4, false, this.iResult);
};

ActGuildAllStar.RivalItem = function()
{
    this.tLeft = new ActGuildAllStar.AnchorItem();
    this.tRight = new ActGuildAllStar.AnchorItem();
    this.iPkState = 0;
    this.lBeginTime = 0;
};
ActGuildAllStar.RivalItem.prototype._clone = function () { return new ActGuildAllStar.RivalItem(); }
ActGuildAllStar.RivalItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.RivalItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.RivalItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tLeft);
    os.writeStruct(1, this.tRight);
    os.writeInt32(2, this.iPkState);
    os.writeInt64(3, this.lBeginTime);
};

ActGuildAllStar.RivalItem.prototype.readFrom = function (is)
{
    this.tLeft= is.readStruct(0, false, this.tLeft);
    this.tRight= is.readStruct(1, false, this.tRight);
    this.iPkState= is.readInt32(2, false, this.iPkState);
    this.lBeginTime= is.readInt64(3, false, this.lBeginTime);
};

ActGuildAllStar.HelpPanel = function()
{
    this.lUnionId = 0;
    this.iMatchId = 0;
    this.lScore = 0;
};
ActGuildAllStar.HelpPanel.prototype._clone = function () { return new ActGuildAllStar.HelpPanel(); }
ActGuildAllStar.HelpPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.HelpPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.HelpPanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUnionId);
    os.writeInt32(1, this.iMatchId);
    os.writeInt64(2, this.lScore);
};

ActGuildAllStar.HelpPanel.prototype.readFrom = function (is)
{
    this.lUnionId= is.readInt64(0, false, this.lUnionId);
    this.iMatchId= is.readInt32(1, false, this.iMatchId);
    this.lScore= is.readInt64(2, false, this.lScore);
};

ActGuildAllStar.RivalPanel = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.RivalItem());
    this.iArea = 0;
    this.lUnionId = 0;
    this.sUnionName = "";
    this.sRivalUnionName = "";
    this.iScore = 0;
    this.iRivalScore = 0;
    this.lWinScore = 0;
    this.lMaxScore = 0;
    this.lGetScore = 0;
    this.tPanel = new ActGuildAllStar.HelpPanel();
    this.iMatchId = 0;
    this.sRivalUnionUrl = "";
};
ActGuildAllStar.RivalPanel.prototype._clone = function () { return new ActGuildAllStar.RivalPanel(); }
ActGuildAllStar.RivalPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.RivalPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.RivalPanel.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iArea);
    os.writeInt64(2, this.lUnionId);
    os.writeString(3, this.sUnionName);
    os.writeString(4, this.sRivalUnionName);
    os.writeInt32(5, this.iScore);
    os.writeInt32(6, this.iRivalScore);
    os.writeInt64(7, this.lWinScore);
    os.writeInt64(8, this.lMaxScore);
    os.writeInt64(9, this.lGetScore);
    os.writeStruct(10, this.tPanel);
    os.writeInt32(11, this.iMatchId);
    os.writeString(12, this.sRivalUnionUrl);
};

ActGuildAllStar.RivalPanel.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.lUnionId= is.readInt64(2, false, this.lUnionId);
    this.sUnionName= is.readString(3, false, this.sUnionName);
    this.sRivalUnionName= is.readString(4, false, this.sRivalUnionName);
    this.iScore= is.readInt32(5, false, this.iScore);
    this.iRivalScore= is.readInt32(6, false, this.iRivalScore);
    this.lWinScore= is.readInt64(7, false, this.lWinScore);
    this.lMaxScore= is.readInt64(8, false, this.lMaxScore);
    this.lGetScore= is.readInt64(9, false, this.lGetScore);
    this.tPanel= is.readStruct(10, false, this.tPanel);
    this.iMatchId= is.readInt32(11, false, this.iMatchId);
    this.sRivalUnionUrl= is.readString(12, false, this.sRivalUnionUrl);
};

ActGuildAllStar.HidePanel = function()
{
    this.lPid = 0;
    this.iActivityId = 0;
};
ActGuildAllStar.HidePanel.prototype._clone = function () { return new ActGuildAllStar.HidePanel(); }
ActGuildAllStar.HidePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.HidePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.HidePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt32(1, this.iActivityId);
};

ActGuildAllStar.HidePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.iActivityId= is.readInt32(1, false, this.iActivityId);
};

ActGuildAllStar.BattleUser = function()
{
    this.lPid = 0;
    this.tJump = new ActGuildAllStar.JumpChannel();
    this.sLogoUrl = "";
    this.sNickName = "";
    this.lUnionId = 0;
    this.sUnionName = "";
    this.lReward = 0;
    this.iPkBuff = 0;
};
ActGuildAllStar.BattleUser.prototype._clone = function () { return new ActGuildAllStar.BattleUser(); }
ActGuildAllStar.BattleUser.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattleUser.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattleUser.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeStruct(1, this.tJump);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sNickName);
    os.writeInt64(4, this.lUnionId);
    os.writeString(5, this.sUnionName);
    os.writeInt64(6, this.lReward);
    os.writeInt32(7, this.iPkBuff);
};

ActGuildAllStar.BattleUser.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.tJump= is.readStruct(1, false, this.tJump);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.lUnionId= is.readInt64(4, false, this.lUnionId);
    this.sUnionName= is.readString(5, false, this.sUnionName);
    this.lReward= is.readInt64(6, false, this.lReward);
    this.iPkBuff= is.readInt32(7, false, this.iPkBuff);
};

ActGuildAllStar.BattleUpdatePanel = function()
{
    this.lAttScore = 0;
    this.lDefScore = 0;
    this.iLeftTime = 0;
    this.iSide = 0;
    this.iKillTime = 0;
    this.lPid = 0;
};
ActGuildAllStar.BattleUpdatePanel.prototype._clone = function () { return new ActGuildAllStar.BattleUpdatePanel(); }
ActGuildAllStar.BattleUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattleUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattleUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lAttScore);
    os.writeInt64(1, this.lDefScore);
    os.writeInt32(2, this.iLeftTime);
    os.writeInt32(3, this.iSide);
    os.writeInt32(4, this.iKillTime);
    os.writeInt64(5, this.lPid);
};

ActGuildAllStar.BattleUpdatePanel.prototype.readFrom = function (is)
{
    this.lAttScore= is.readInt64(0, false, this.lAttScore);
    this.lDefScore= is.readInt64(1, false, this.lDefScore);
    this.iLeftTime= is.readInt32(2, false, this.iLeftTime);
    this.iSide= is.readInt32(3, false, this.iSide);
    this.iKillTime= is.readInt32(4, false, this.iKillTime);
    this.lPid= is.readInt64(5, false, this.lPid);
};

ActGuildAllStar.BattlePanel = function()
{
    this.tAttUser = new ActGuildAllStar.BattleUser();
    this.tDefUser = new ActGuildAllStar.BattleUser();
    this.tUpdate = new ActGuildAllStar.BattleUpdatePanel();
    this.iPkType = 0;
    this.iStage = 0;
    this.iArea = 0;
    this.iRound = 0;
    this.iAttWin = 0;
    this.iDefWin = 0;
};
ActGuildAllStar.BattlePanel.prototype._clone = function () { return new ActGuildAllStar.BattlePanel(); }
ActGuildAllStar.BattlePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattlePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattlePanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tAttUser);
    os.writeStruct(1, this.tDefUser);
    os.writeStruct(2, this.tUpdate);
    os.writeInt32(3, this.iPkType);
    os.writeInt32(4, this.iStage);
    os.writeInt32(5, this.iArea);
    os.writeInt32(6, this.iRound);
    os.writeInt32(7, this.iAttWin);
    os.writeInt32(8, this.iDefWin);
};

ActGuildAllStar.BattlePanel.prototype.readFrom = function (is)
{
    this.tAttUser= is.readStruct(0, false, this.tAttUser);
    this.tDefUser= is.readStruct(1, false, this.tDefUser);
    this.tUpdate= is.readStruct(2, false, this.tUpdate);
    this.iPkType= is.readInt32(3, false, this.iPkType);
    this.iStage= is.readInt32(4, false, this.iStage);
    this.iArea= is.readInt32(5, false, this.iArea);
    this.iRound= is.readInt32(6, false, this.iRound);
    this.iAttWin= is.readInt32(7, false, this.iAttWin);
    this.iDefWin= is.readInt32(8, false, this.iDefWin);
};

ActGuildAllStar.BattleAnnouncePanel = function()
{
    this.tBattle = new ActGuildAllStar.BattlePanel();
    this.iBuffCount = 0;
};
ActGuildAllStar.BattleAnnouncePanel.prototype._clone = function () { return new ActGuildAllStar.BattleAnnouncePanel(); }
ActGuildAllStar.BattleAnnouncePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattleAnnouncePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattleAnnouncePanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBattle);
    os.writeInt32(1, this.iBuffCount);
};

ActGuildAllStar.BattleAnnouncePanel.prototype.readFrom = function (is)
{
    this.tBattle= is.readStruct(0, false, this.tBattle);
    this.iBuffCount= is.readInt32(1, false, this.iBuffCount);
};

ActGuildAllStar.BattleResultPanel = function()
{
    this.tBattle = new ActGuildAllStar.BattlePanel();
    this.lDeltaScore = 0;
    this.iResult = 0;
    this.lPresentScore = 0;
    this.iRound = 0;
    this.iAttWin = 0;
    this.iDefWin = 0;
};
ActGuildAllStar.BattleResultPanel.prototype._clone = function () { return new ActGuildAllStar.BattleResultPanel(); }
ActGuildAllStar.BattleResultPanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattleResultPanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattleResultPanel.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tBattle);
    os.writeInt64(1, this.lDeltaScore);
    os.writeInt32(2, this.iResult);
    os.writeInt64(3, this.lPresentScore);
    os.writeInt32(4, this.iRound);
    os.writeInt32(5, this.iAttWin);
    os.writeInt32(6, this.iDefWin);
};

ActGuildAllStar.BattleResultPanel.prototype.readFrom = function (is)
{
    this.tBattle= is.readStruct(0, false, this.tBattle);
    this.lDeltaScore= is.readInt64(1, false, this.lDeltaScore);
    this.iResult= is.readInt32(2, false, this.iResult);
    this.lPresentScore= is.readInt64(3, false, this.lPresentScore);
    this.iRound= is.readInt32(4, false, this.iRound);
    this.iAttWin= is.readInt32(5, false, this.iAttWin);
    this.iDefWin= is.readInt32(6, false, this.iDefWin);
};

ActGuildAllStar.BattleFansScoreItem = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.lScore = 0;
};
ActGuildAllStar.BattleFansScoreItem.prototype._clone = function () { return new ActGuildAllStar.BattleFansScoreItem(); }
ActGuildAllStar.BattleFansScoreItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattleFansScoreItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattleFansScoreItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt64(2, this.lScore);
};

ActGuildAllStar.BattleFansScoreItem.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.lScore= is.readInt64(2, false, this.lScore);
};

ActGuildAllStar.BattleFansScorePanel = function()
{
    this.iPkType = 0;
    this.lAttUnionScore = 0;
    this.lDefUnionScore = 0;
    this.vAttFansScore = new Taf.Vector(new ActGuildAllStar.BattleFansScoreItem());
    this.vDefFansScore = new Taf.Vector(new ActGuildAllStar.BattleFansScoreItem());
    this.lPid = 0;
};
ActGuildAllStar.BattleFansScorePanel.prototype._clone = function () { return new ActGuildAllStar.BattleFansScorePanel(); }
ActGuildAllStar.BattleFansScorePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.BattleFansScorePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.BattleFansScorePanel.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iPkType);
    os.writeInt64(1, this.lAttUnionScore);
    os.writeInt64(2, this.lDefUnionScore);
    os.writeVector(3, this.vAttFansScore);
    os.writeVector(4, this.vDefFansScore);
    os.writeInt64(5, this.lPid);
};

ActGuildAllStar.BattleFansScorePanel.prototype.readFrom = function (is)
{
    this.iPkType= is.readInt32(0, false, this.iPkType);
    this.lAttUnionScore= is.readInt64(1, false, this.lAttUnionScore);
    this.lDefUnionScore= is.readInt64(2, false, this.lDefUnionScore);
    this.vAttFansScore= is.readVector(3, false, this.vAttFansScore);
    this.vDefFansScore= is.readVector(4, false, this.vDefFansScore);
    this.lPid= is.readInt64(5, false, this.lPid);
};

ActGuildAllStar.AttackReq = function()
{
    this.tAttackId = new HUYA.UserId();
    this.lDefUid = 0;
};
ActGuildAllStar.AttackReq.prototype._clone = function () { return new ActGuildAllStar.AttackReq(); }
ActGuildAllStar.AttackReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AttackReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AttackReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tAttackId);
    os.writeInt64(1, this.lDefUid);
};

ActGuildAllStar.AttackReq.prototype.readFrom = function (is)
{
    this.tAttackId= is.readStruct(0, false, this.tAttackId);
    this.lDefUid= is.readInt64(1, false, this.lDefUid);
};

ActGuildAllStar.AttackRsp = function()
{
    this.iResult = 0;
    this.lAttPid = 0;
    this.lDefPid = 0;
    this.sDesc = "";
    this.sDesc2 = "";
};
ActGuildAllStar.AttackRsp.prototype._clone = function () { return new ActGuildAllStar.AttackRsp(); }
ActGuildAllStar.AttackRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AttackRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AttackRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iResult);
    os.writeInt64(1, this.lAttPid);
    os.writeInt64(2, this.lDefPid);
    os.writeString(3, this.sDesc);
    os.writeString(4, this.sDesc2);
};

ActGuildAllStar.AttackRsp.prototype.readFrom = function (is)
{
    this.iResult= is.readInt32(0, false, this.iResult);
    this.lAttPid= is.readInt64(1, false, this.lAttPid);
    this.lDefPid= is.readInt64(2, false, this.lDefPid);
    this.sDesc= is.readString(3, false, this.sDesc);
    this.sDesc2= is.readString(4, false, this.sDesc2);
};

ActGuildAllStar.AttackSearchItem = function()
{
    this.lPid = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
    this.lScore = 0;
    this.iAttTime = 0;
    this.iDefTime = 0;
    this.iType = 0;
    this.sUnionName = "";
};
ActGuildAllStar.AttackSearchItem.prototype._clone = function () { return new ActGuildAllStar.AttackSearchItem(); }
ActGuildAllStar.AttackSearchItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AttackSearchItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AttackSearchItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeInt64(3, this.lScore);
    os.writeInt32(4, this.iAttTime);
    os.writeInt32(5, this.iDefTime);
    os.writeInt32(6, this.iType);
    os.writeString(7, this.sUnionName);
};

ActGuildAllStar.AttackSearchItem.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.lScore= is.readInt64(3, false, this.lScore);
    this.iAttTime= is.readInt32(4, false, this.iAttTime);
    this.iDefTime= is.readInt32(5, false, this.iDefTime);
    this.iType= is.readInt32(6, false, this.iType);
    this.sUnionName= is.readString(7, false, this.sUnionName);
};

ActGuildAllStar.AttackSearchReq = function()
{
    this.lUid = 0;
    this.sNickName = "";
    this.iTimes = 0;
};
ActGuildAllStar.AttackSearchReq.prototype._clone = function () { return new ActGuildAllStar.AttackSearchReq(); }
ActGuildAllStar.AttackSearchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AttackSearchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AttackSearchReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sNickName);
    os.writeInt32(2, this.iTimes);
};

ActGuildAllStar.AttackSearchReq.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.iTimes= is.readInt32(2, false, this.iTimes);
};

ActGuildAllStar.AttackSearchRsp = function()
{
    this.vItems = new Taf.Vector(new ActGuildAllStar.AttackSearchItem());
};
ActGuildAllStar.AttackSearchRsp.prototype._clone = function () { return new ActGuildAllStar.AttackSearchRsp(); }
ActGuildAllStar.AttackSearchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AttackSearchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AttackSearchRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vItems);
};

ActGuildAllStar.AttackSearchRsp.prototype.readFrom = function (is)
{
    this.vItems= is.readVector(0, false, this.vItems);
};

ActGuildAllStar.UserTaskState = function()
{
    this.lTaskId = 0;
    this.sTaskDesc = "";
    this.iState = 0;
    this.iTaskLevel = 0;
    this.iNowExperience = 0;
    this.iNextExperience = 0;
    this.iFinishedTime = 0;
};
ActGuildAllStar.UserTaskState.prototype._clone = function () { return new ActGuildAllStar.UserTaskState(); }
ActGuildAllStar.UserTaskState.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.UserTaskState.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.UserTaskState.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lTaskId);
    os.writeString(1, this.sTaskDesc);
    os.writeInt32(2, this.iState);
    os.writeInt32(3, this.iTaskLevel);
    os.writeInt32(4, this.iNowExperience);
    os.writeInt32(5, this.iNextExperience);
    os.writeInt32(6, this.iFinishedTime);
};

ActGuildAllStar.UserTaskState.prototype.readFrom = function (is)
{
    this.lTaskId= is.readInt64(0, false, this.lTaskId);
    this.sTaskDesc= is.readString(1, false, this.sTaskDesc);
    this.iState= is.readInt32(2, false, this.iState);
    this.iTaskLevel= is.readInt32(3, false, this.iTaskLevel);
    this.iNowExperience= is.readInt32(4, false, this.iNowExperience);
    this.iNextExperience= is.readInt32(5, false, this.iNextExperience);
    this.iFinishedTime= is.readInt32(6, false, this.iFinishedTime);
};

ActGuildAllStar.AwardItem = function()
{
    this.lGetTime = 0;
    this.sAward = "";
    this.iIsBigAward = 0;
};
ActGuildAllStar.AwardItem.prototype._clone = function () { return new ActGuildAllStar.AwardItem(); }
ActGuildAllStar.AwardItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.AwardItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.AwardItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lGetTime);
    os.writeString(1, this.sAward);
    os.writeInt32(2, this.iIsBigAward);
};

ActGuildAllStar.AwardItem.prototype.readFrom = function (is)
{
    this.lGetTime= is.readInt64(0, false, this.lGetTime);
    this.sAward= is.readString(1, false, this.sAward);
    this.iIsBigAward= is.readInt32(2, false, this.iIsBigAward);
};

ActGuildAllStar.TaskUpdatePanel = function()
{
    this.lPid = 0;
    this.lTopTaskId = 0;
    this.vTaskList = new Taf.Vector(new ActGuildAllStar.UserTaskState());
    this.iGetNum = 0;
    this.iLeftNum = 0;
    this.vAward = new Taf.Vector(new ActGuildAllStar.AwardItem());
};
ActGuildAllStar.TaskUpdatePanel.prototype._clone = function () { return new ActGuildAllStar.TaskUpdatePanel(); }
ActGuildAllStar.TaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.TaskUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.TaskUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTopTaskId);
    os.writeVector(2, this.vTaskList);
    os.writeInt32(3, this.iGetNum);
    os.writeInt32(4, this.iLeftNum);
    os.writeVector(5, this.vAward);
};

ActGuildAllStar.TaskUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTopTaskId= is.readInt64(1, false, this.lTopTaskId);
    this.vTaskList= is.readVector(2, false, this.vTaskList);
    this.iGetNum= is.readInt32(3, false, this.iGetNum);
    this.iLeftNum= is.readInt32(4, false, this.iLeftNum);
    this.vAward= is.readVector(5, false, this.vAward);
};

ActGuildAllStar.SingleTaskUpdatePanel = function()
{
    this.lPid = 0;
    this.tTaskItem = new ActGuildAllStar.UserTaskState();
};
ActGuildAllStar.SingleTaskUpdatePanel.prototype._clone = function () { return new ActGuildAllStar.SingleTaskUpdatePanel(); }
ActGuildAllStar.SingleTaskUpdatePanel.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.SingleTaskUpdatePanel.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.SingleTaskUpdatePanel.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeStruct(1, this.tTaskItem);
};

ActGuildAllStar.SingleTaskUpdatePanel.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.tTaskItem= is.readStruct(1, false, this.tTaskItem);
};

ActGuildAllStar.TopTaskReq = function()
{
    this.lPid = 0;
    this.lTaskId = 0;
};
ActGuildAllStar.TopTaskReq.prototype._clone = function () { return new ActGuildAllStar.TopTaskReq(); }
ActGuildAllStar.TopTaskReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.TopTaskReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.TopTaskReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lPid);
    os.writeInt64(1, this.lTaskId);
};

ActGuildAllStar.TopTaskReq.prototype.readFrom = function (is)
{
    this.lPid= is.readInt64(0, false, this.lPid);
    this.lTaskId= is.readInt64(1, false, this.lTaskId);
};

ActGuildAllStar.TopTaskRsp = function()
{
    this.iRet = 0;
    this.sMsg = "";
    this.tUserTaskState = new ActGuildAllStar.UserTaskState();
};
ActGuildAllStar.TopTaskRsp.prototype._clone = function () { return new ActGuildAllStar.TopTaskRsp(); }
ActGuildAllStar.TopTaskRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.TopTaskRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.TopTaskRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sMsg);
    os.writeStruct(2, this.tUserTaskState);
};

ActGuildAllStar.TopTaskRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sMsg= is.readString(1, false, this.sMsg);
    this.tUserTaskState= is.readStruct(2, false, this.tUserTaskState);
};

ActGuildAllStar.OpenBoxReq = function()
{
    this.tPid = new HUYA.UserId();
};
ActGuildAllStar.OpenBoxReq.prototype._clone = function () { return new ActGuildAllStar.OpenBoxReq(); }
ActGuildAllStar.OpenBoxReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.OpenBoxReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.OpenBoxReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPid);
};

ActGuildAllStar.OpenBoxReq.prototype.readFrom = function (is)
{
    this.tPid= is.readStruct(0, false, this.tPid);
};

ActGuildAllStar.OpenBoxRsp = function()
{
    this.iRet = 0;
    this.sMsg = "";
    this.sAward = "";
    this.sAwardLogo = "";
    this.iAwardType = 0;
    this.iGetNum = 0;
    this.iLeftNum = 0;
};
ActGuildAllStar.OpenBoxRsp.prototype._clone = function () { return new ActGuildAllStar.OpenBoxRsp(); }
ActGuildAllStar.OpenBoxRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.OpenBoxRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.OpenBoxRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sMsg);
    os.writeString(2, this.sAward);
    os.writeString(3, this.sAwardLogo);
    os.writeInt32(4, this.iAwardType);
    os.writeInt32(5, this.iGetNum);
    os.writeInt32(6, this.iLeftNum);
};

ActGuildAllStar.OpenBoxRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sMsg= is.readString(1, false, this.sMsg);
    this.sAward= is.readString(2, false, this.sAward);
    this.sAwardLogo= is.readString(3, false, this.sAwardLogo);
    this.iAwardType= is.readInt32(4, false, this.iAwardType);
    this.iGetNum= is.readInt32(5, false, this.iGetNum);
    this.iLeftNum= is.readInt32(6, false, this.iLeftNum);
};

ActGuildAllStar.GetStageReq = function()
{
    this.iActId = 0;
    this.lPid = 0;
};
ActGuildAllStar.GetStageReq.prototype._clone = function () { return new ActGuildAllStar.GetStageReq(); }
ActGuildAllStar.GetStageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetStageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetStageReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iActId);
    os.writeInt64(1, this.lPid);
};

ActGuildAllStar.GetStageReq.prototype.readFrom = function (is)
{
    this.iActId= is.readInt32(0, false, this.iActId);
    this.lPid= is.readInt64(1, false, this.lPid);
};

ActGuildAllStar.GetStageRsp = function()
{
    this.iStage = 0;
    this.iDay = 0;
    this.iArea = 0;
};
ActGuildAllStar.GetStageRsp.prototype._clone = function () { return new ActGuildAllStar.GetStageRsp(); }
ActGuildAllStar.GetStageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetStageRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetStageRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iDay);
    os.writeInt32(2, this.iArea);
};

ActGuildAllStar.GetStageRsp.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iDay= is.readInt32(1, false, this.iDay);
    this.iArea= is.readInt32(2, false, this.iArea);
};

ActGuildAllStar.GetPkStageReq = function()
{
    this.iActId = 0;
    this.iStage = 0;
    this.lPid = 0;
};
ActGuildAllStar.GetPkStageReq.prototype._clone = function () { return new ActGuildAllStar.GetPkStageReq(); }
ActGuildAllStar.GetPkStageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetPkStageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetPkStageReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iActId);
    os.writeInt32(1, this.iStage);
    os.writeInt64(2, this.lPid);
};

ActGuildAllStar.GetPkStageReq.prototype.readFrom = function (is)
{
    this.iActId= is.readInt32(0, false, this.iActId);
    this.iStage= is.readInt32(1, false, this.iStage);
    this.lPid= is.readInt64(2, false, this.lPid);
};

ActGuildAllStar.GetPkStageRsp = function()
{
    this.iStage = 0;
    this.iDay = 0;
    this.iTotalDay = 0;
    this.iArea = 0;
    this.iRound = 0;
    this.mRound2Hour = new Taf.Map(new Taf.INT32(), new Taf.INT32());
};
ActGuildAllStar.GetPkStageRsp.prototype._clone = function () { return new ActGuildAllStar.GetPkStageRsp(); }
ActGuildAllStar.GetPkStageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetPkStageRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetPkStageRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iDay);
    os.writeInt32(2, this.iTotalDay);
    os.writeInt32(3, this.iArea);
    os.writeInt32(4, this.iRound);
    os.writeMap(5, this.mRound2Hour);
};

ActGuildAllStar.GetPkStageRsp.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iDay= is.readInt32(1, false, this.iDay);
    this.iTotalDay= is.readInt32(2, false, this.iTotalDay);
    this.iArea= is.readInt32(3, false, this.iArea);
    this.iRound= is.readInt32(4, false, this.iRound);
    this.mRound2Hour= is.readMap(5, false, this.mRound2Hour);
};

ActGuildAllStar.GetHourRankReq = function()
{
    this.iStage = 0;
    this.lPid = 0;
};
ActGuildAllStar.GetHourRankReq.prototype._clone = function () { return new ActGuildAllStar.GetHourRankReq(); }
ActGuildAllStar.GetHourRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetHourRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetHourRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt64(1, this.lPid);
};

ActGuildAllStar.GetHourRankReq.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.lPid= is.readInt64(1, false, this.lPid);
};

ActGuildAllStar.HourTopItem = function()
{
    this.tJump = new ActGuildAllStar.JumpChannel();
    this.sNickName = "";
    this.sLogoUrl = "";
    this.sDesc = "";
};
ActGuildAllStar.HourTopItem.prototype._clone = function () { return new ActGuildAllStar.HourTopItem(); }
ActGuildAllStar.HourTopItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.HourTopItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.HourTopItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tJump);
    os.writeString(1, this.sNickName);
    os.writeString(2, this.sLogoUrl);
    os.writeString(3, this.sDesc);
};

ActGuildAllStar.HourTopItem.prototype.readFrom = function (is)
{
    this.tJump= is.readStruct(0, false, this.tJump);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.sLogoUrl= is.readString(2, false, this.sLogoUrl);
    this.sDesc= is.readString(3, false, this.sDesc);
};

ActGuildAllStar.GetHourRankRsp = function()
{
    this.iCurStage = 0;
    this.vGameRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.vEntertainmentRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.vGameHourRank = new Taf.Vector(new ActGuildAllStar.HourTopItem());
    this.vEntertainmentHourRank = new Taf.Vector(new ActGuildAllStar.HourTopItem());
    this.tPidGameRank = new ActGuildAllStar.RankItem();
    this.tPidEntertainmentRank = new ActGuildAllStar.RankItem();
};
ActGuildAllStar.GetHourRankRsp.prototype._clone = function () { return new ActGuildAllStar.GetHourRankRsp(); }
ActGuildAllStar.GetHourRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetHourRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetHourRankRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCurStage);
    os.writeVector(1, this.vGameRank);
    os.writeVector(2, this.vEntertainmentRank);
    os.writeVector(3, this.vGameHourRank);
    os.writeVector(4, this.vEntertainmentHourRank);
    os.writeStruct(5, this.tPidGameRank);
    os.writeStruct(6, this.tPidEntertainmentRank);
};

ActGuildAllStar.GetHourRankRsp.prototype.readFrom = function (is)
{
    this.iCurStage= is.readInt32(0, false, this.iCurStage);
    this.vGameRank= is.readVector(1, false, this.vGameRank);
    this.vEntertainmentRank= is.readVector(2, false, this.vEntertainmentRank);
    this.vGameHourRank= is.readVector(3, false, this.vGameHourRank);
    this.vEntertainmentHourRank= is.readVector(4, false, this.vEntertainmentHourRank);
    this.tPidGameRank= is.readStruct(5, false, this.tPidGameRank);
    this.tPidEntertainmentRank= is.readStruct(6, false, this.tPidEntertainmentRank);
};

ActGuildAllStar.GetGuildRankReq = function()
{
    this.iStage = 0;
    this.iArea = 0;
    this.iRevive = 0;
};
ActGuildAllStar.GetGuildRankReq.prototype._clone = function () { return new ActGuildAllStar.GetGuildRankReq(); }
ActGuildAllStar.GetGuildRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iArea);
    os.writeInt32(2, this.iRevive);
};

ActGuildAllStar.GetGuildRankReq.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.iRevive= is.readInt32(2, false, this.iRevive);
};

ActGuildAllStar.GuildItem = function()
{
    this.lCompanyId = 0;
    this.sCompanyName = "";
    this.sCompanyLogoUrl = "";
    this.iRank = 0;
    this.lScore = 0;
    this.vRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.sDesc = "";
};
ActGuildAllStar.GuildItem.prototype._clone = function () { return new ActGuildAllStar.GuildItem(); }
ActGuildAllStar.GuildItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GuildItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GuildItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lCompanyId);
    os.writeString(1, this.sCompanyName);
    os.writeString(2, this.sCompanyLogoUrl);
    os.writeInt32(3, this.iRank);
    os.writeInt64(4, this.lScore);
    os.writeVector(5, this.vRank);
    os.writeString(6, this.sDesc);
};

ActGuildAllStar.GuildItem.prototype.readFrom = function (is)
{
    this.lCompanyId= is.readInt64(0, false, this.lCompanyId);
    this.sCompanyName= is.readString(1, false, this.sCompanyName);
    this.sCompanyLogoUrl= is.readString(2, false, this.sCompanyLogoUrl);
    this.iRank= is.readInt32(3, false, this.iRank);
    this.lScore= is.readInt64(4, false, this.lScore);
    this.vRank= is.readVector(5, false, this.vRank);
    this.sDesc= is.readString(6, false, this.sDesc);
};

ActGuildAllStar.GetGuildRankRsp = function()
{
    this.iCurStage = 0;
    this.vRank = new Taf.Vector(new ActGuildAllStar.GuildItem());
};
ActGuildAllStar.GetGuildRankRsp.prototype._clone = function () { return new ActGuildAllStar.GetGuildRankRsp(); }
ActGuildAllStar.GetGuildRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildRankRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCurStage);
    os.writeVector(1, this.vRank);
};

ActGuildAllStar.GetGuildRankRsp.prototype.readFrom = function (is)
{
    this.iCurStage= is.readInt32(0, false, this.iCurStage);
    this.vRank= is.readVector(1, false, this.vRank);
};

ActGuildAllStar.GetRichRankRsp = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.RankItem());
};
ActGuildAllStar.GetRichRankRsp.prototype._clone = function () { return new ActGuildAllStar.GetRichRankRsp(); }
ActGuildAllStar.GetRichRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetRichRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetRichRankRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
};

ActGuildAllStar.GetRichRankRsp.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
};

ActGuildAllStar.GetGuildDetailReq = function()
{
    this.iStage = 0;
    this.lCompanyId = 0;
    this.iArea = 0;
};
ActGuildAllStar.GetGuildDetailReq.prototype._clone = function () { return new ActGuildAllStar.GetGuildDetailReq(); }
ActGuildAllStar.GetGuildDetailReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildDetailReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildDetailReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt64(1, this.lCompanyId);
    os.writeInt32(2, this.iArea);
};

ActGuildAllStar.GetGuildDetailReq.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.lCompanyId= is.readInt64(1, false, this.lCompanyId);
    this.iArea= is.readInt32(2, false, this.iArea);
};

ActGuildAllStar.GetGuildDetailRsp = function()
{
    this.iCurStage = 0;
    this.sNickName = "";
    this.vRich = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.vContribution = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.vContributionTotal = new Taf.Vector(new ActGuildAllStar.RankItem());
};
ActGuildAllStar.GetGuildDetailRsp.prototype._clone = function () { return new ActGuildAllStar.GetGuildDetailRsp(); }
ActGuildAllStar.GetGuildDetailRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildDetailRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildDetailRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCurStage);
    os.writeString(1, this.sNickName);
    os.writeVector(2, this.vRich);
    os.writeVector(3, this.vContribution);
    os.writeVector(4, this.vContributionTotal);
};

ActGuildAllStar.GetGuildDetailRsp.prototype.readFrom = function (is)
{
    this.iCurStage= is.readInt32(0, false, this.iCurStage);
    this.sNickName= is.readString(1, false, this.sNickName);
    this.vRich= is.readVector(2, false, this.vRich);
    this.vContribution= is.readVector(3, false, this.vContribution);
    this.vContributionTotal= is.readVector(4, false, this.vContributionTotal);
};

ActGuildAllStar.GetGuildRankSpReq = function()
{
    this.iActId = 0;
    this.iStage = 0;
    this.iArea = 0;
    this.iRevive = 0;
};
ActGuildAllStar.GetGuildRankSpReq.prototype._clone = function () { return new ActGuildAllStar.GetGuildRankSpReq(); }
ActGuildAllStar.GetGuildRankSpReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildRankSpReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildRankSpReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iActId);
    os.writeInt32(1, this.iStage);
    os.writeInt32(2, this.iArea);
    os.writeInt32(3, this.iRevive);
};

ActGuildAllStar.GetGuildRankSpReq.prototype.readFrom = function (is)
{
    this.iActId= is.readInt32(0, false, this.iActId);
    this.iStage= is.readInt32(1, false, this.iStage);
    this.iArea= is.readInt32(2, false, this.iArea);
    this.iRevive= is.readInt32(3, false, this.iRevive);
};

ActGuildAllStar.GetGuildRankSpRsp = function()
{
    this.iCurStage = 0;
    this.vRank = new Taf.Vector(new ActGuildAllStar.GuildItem());
    this.vRsp = new Taf.Vector(new ActGuildAllStar.GetGuildDetailRsp());
};
ActGuildAllStar.GetGuildRankSpRsp.prototype._clone = function () { return new ActGuildAllStar.GetGuildRankSpRsp(); }
ActGuildAllStar.GetGuildRankSpRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildRankSpRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildRankSpRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCurStage);
    os.writeVector(1, this.vRank);
    os.writeVector(2, this.vRsp);
};

ActGuildAllStar.GetGuildRankSpRsp.prototype.readFrom = function (is)
{
    this.iCurStage= is.readInt32(0, false, this.iCurStage);
    this.vRank= is.readVector(1, false, this.vRank);
    this.vRsp= is.readVector(2, false, this.vRsp);
};

ActGuildAllStar.GetGuildPkDetailReq = function()
{
    this.iStage = 0;
    this.iDay = 0;
    this.iRound = 0;
    this.iArea = 0;
    this.iRevive = 0;
};
ActGuildAllStar.GetGuildPkDetailReq.prototype._clone = function () { return new ActGuildAllStar.GetGuildPkDetailReq(); }
ActGuildAllStar.GetGuildPkDetailReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildPkDetailReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildPkDetailReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iDay);
    os.writeInt32(2, this.iRound);
    os.writeInt32(3, this.iArea);
    os.writeInt32(4, this.iRevive);
};

ActGuildAllStar.GetGuildPkDetailReq.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iDay= is.readInt32(1, false, this.iDay);
    this.iRound= is.readInt32(2, false, this.iRound);
    this.iArea= is.readInt32(3, false, this.iArea);
    this.iRevive= is.readInt32(4, false, this.iRevive);
};

ActGuildAllStar.GuildPkMatchItem = function()
{
    this.tAttSide = new ActGuildAllStar.RankItem();
    this.tDefSide = new ActGuildAllStar.RankItem();
    this.iMatch = 0;
    this.iResult = 0;
    this.sDesc = "";
    this.iStatus = 0;
};
ActGuildAllStar.GuildPkMatchItem.prototype._clone = function () { return new ActGuildAllStar.GuildPkMatchItem(); }
ActGuildAllStar.GuildPkMatchItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GuildPkMatchItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GuildPkMatchItem.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tAttSide);
    os.writeStruct(1, this.tDefSide);
    os.writeInt32(2, this.iMatch);
    os.writeInt32(3, this.iResult);
    os.writeString(4, this.sDesc);
    os.writeInt32(5, this.iStatus);
};

ActGuildAllStar.GuildPkMatchItem.prototype.readFrom = function (is)
{
    this.tAttSide= is.readStruct(0, false, this.tAttSide);
    this.tDefSide= is.readStruct(1, false, this.tDefSide);
    this.iMatch= is.readInt32(2, false, this.iMatch);
    this.iResult= is.readInt32(3, false, this.iResult);
    this.sDesc= is.readString(4, false, this.sDesc);
    this.iStatus= is.readInt32(5, false, this.iStatus);
};

ActGuildAllStar.GuildPkRoundItem = function()
{
    this.sAttGuildName = "";
    this.sAttGuildLogo = "";
    this.sDefGuildName = "";
    this.sDefGuildLogo = "";
    this.iAttWin = 0;
    this.iDefWin = 0;
    this.vMatch = new Taf.Vector(new ActGuildAllStar.GuildPkMatchItem());
};
ActGuildAllStar.GuildPkRoundItem.prototype._clone = function () { return new ActGuildAllStar.GuildPkRoundItem(); }
ActGuildAllStar.GuildPkRoundItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GuildPkRoundItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GuildPkRoundItem.prototype.writeTo = function (os)
{
    os.writeString(0, this.sAttGuildName);
    os.writeString(1, this.sAttGuildLogo);
    os.writeString(2, this.sDefGuildName);
    os.writeString(3, this.sDefGuildLogo);
    os.writeInt32(4, this.iAttWin);
    os.writeInt32(5, this.iDefWin);
    os.writeVector(6, this.vMatch);
};

ActGuildAllStar.GuildPkRoundItem.prototype.readFrom = function (is)
{
    this.sAttGuildName= is.readString(0, false, this.sAttGuildName);
    this.sAttGuildLogo= is.readString(1, false, this.sAttGuildLogo);
    this.sDefGuildName= is.readString(2, false, this.sDefGuildName);
    this.sDefGuildLogo= is.readString(3, false, this.sDefGuildLogo);
    this.iAttWin= is.readInt32(4, false, this.iAttWin);
    this.iDefWin= is.readInt32(5, false, this.iDefWin);
    this.vMatch= is.readVector(6, false, this.vMatch);
};

ActGuildAllStar.GetGuildPkDetailRsp = function()
{
    this.iCurStage = 0;
    this.iDay = 0;
    this.iRound = 0;
    this.vRank = new Taf.Vector(new ActGuildAllStar.GuildPkRoundItem());
};
ActGuildAllStar.GetGuildPkDetailRsp.prototype._clone = function () { return new ActGuildAllStar.GetGuildPkDetailRsp(); }
ActGuildAllStar.GetGuildPkDetailRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetGuildPkDetailRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetGuildPkDetailRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCurStage);
    os.writeInt32(1, this.iDay);
    os.writeInt32(2, this.iRound);
    os.writeVector(3, this.vRank);
};

ActGuildAllStar.GetGuildPkDetailRsp.prototype.readFrom = function (is)
{
    this.iCurStage= is.readInt32(0, false, this.iCurStage);
    this.iDay= is.readInt32(1, false, this.iDay);
    this.iRound= is.readInt32(2, false, this.iRound);
    this.vRank= is.readVector(3, false, this.vRank);
};

ActGuildAllStar.GetContributeRankReq = function()
{
    this.iStage = 0;
    this.iArea = 0;
    this.lCompanyId = 0;
    this.lPid = 0;
};
ActGuildAllStar.GetContributeRankReq.prototype._clone = function () { return new ActGuildAllStar.GetContributeRankReq(); }
ActGuildAllStar.GetContributeRankReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetContributeRankReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetContributeRankReq.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iStage);
    os.writeInt32(1, this.iArea);
    os.writeInt64(2, this.lCompanyId);
    os.writeInt64(3, this.lPid);
};

ActGuildAllStar.GetContributeRankReq.prototype.readFrom = function (is)
{
    this.iStage= is.readInt32(0, false, this.iStage);
    this.iArea= is.readInt32(1, false, this.iArea);
    this.lCompanyId= is.readInt64(2, false, this.lCompanyId);
    this.lPid= is.readInt64(3, false, this.lPid);
};

ActGuildAllStar.GetContributeRankRsp = function()
{
    this.vRank = new Taf.Vector(new ActGuildAllStar.RankItem());
    this.iRank = 0;
    this.lScore = 0;
    this.sNickName = "";
    this.sLogoUrl = "";
};
ActGuildAllStar.GetContributeRankRsp.prototype._clone = function () { return new ActGuildAllStar.GetContributeRankRsp(); }
ActGuildAllStar.GetContributeRankRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.GetContributeRankRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.GetContributeRankRsp.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRank);
    os.writeInt32(1, this.iRank);
    os.writeInt64(2, this.lScore);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sLogoUrl);
};

ActGuildAllStar.GetContributeRankRsp.prototype.readFrom = function (is)
{
    this.vRank= is.readVector(0, false, this.vRank);
    this.iRank= is.readInt32(1, false, this.iRank);
    this.lScore= is.readInt64(2, false, this.lScore);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sLogoUrl= is.readString(4, false, this.sLogoUrl);
};

ActGuildAllStar.EnablePkBuffReq = function()
{
    this.tPid = new HUYA.UserId();
};
ActGuildAllStar.EnablePkBuffReq.prototype._clone = function () { return new ActGuildAllStar.EnablePkBuffReq(); }
ActGuildAllStar.EnablePkBuffReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.EnablePkBuffReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.EnablePkBuffReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tPid);
};

ActGuildAllStar.EnablePkBuffReq.prototype.readFrom = function (is)
{
    this.tPid= is.readStruct(0, false, this.tPid);
};

ActGuildAllStar.EnablePkBuffRsp = function()
{
    this.iRet = 0;
    this.sErrMsg = "";
};
ActGuildAllStar.EnablePkBuffRsp.prototype._clone = function () { return new ActGuildAllStar.EnablePkBuffRsp(); }
ActGuildAllStar.EnablePkBuffRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
ActGuildAllStar.EnablePkBuffRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

ActGuildAllStar.EnablePkBuffRsp.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRet);
    os.writeString(1, this.sErrMsg);
};

ActGuildAllStar.EnablePkBuffRsp.prototype.readFrom = function (is)
{
    this.iRet= is.readInt32(0, false, this.iRet);
    this.sErrMsg= is.readString(1, false, this.sErrMsg);
};

export default ActGuildAllStar;

